import { Injectable, ɵɵdefineInjectable, ɵɵinject, EventEmitter, Component, Output, Inject, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store, createFeatureSelector, createSelector, select, StoreModule } from '@ngrx/store';
import { Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { from, timer, of, throwError, Subject, BehaviorSubject, Observable, iif } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatInputModule, MatButtonModule, MatIconModule } from '@angular/material';
import { take, filter, catchError, map, distinctUntilChanged, switchMap, takeWhile, timeoutWith, tap, takeUntil, mergeMap, throttleTime } from 'rxjs/operators';
import { firestore, auth } from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { HttpClient } from '@angular/common/http';
import { __assign, __decorate, __metadata, __read } from 'tslib';
import { ofType, Actions, Effect, EffectsModule } from '@ngrx/effects';
import { Router } from '@angular/router';
import { MatDialog as MatDialog$1, MatDialogModule } from '@angular/material/dialog';
import { createEntityAdapter } from '@ngrx/entity';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar as MatSnackBar$1 } from '@angular/material/snack-bar';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/actions/x-public.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ActionXPublicTypes = {
    ADD_USER: "[XAuth] Agregar usuario",
    UPSERT_MANY_PUBLIC: "[XAuth] Agregar varios estados",
    UPDATE_PUBLIC: "[XAuth] Actualizar estado",
    UPDATE_ALL_PUBLIC: "[XAuth] Actualizar todo el estado",
    XGET_USER: "[XAuth] User",
    IS_NEW: "[XAuth] Es un usuario nuevo",
    AUTHENTICATED: "[XAuth] Autenticado",
    NOT_AUTHENTICATED: "[XAuth] Sin autenticar",
    GOOGLE_LOGIN: "[XAuth] Ingreso o registro por google",
    SIGNINSOCIAL: "[XAuth] Ingreso Redes sociales",
    MAIL_SIGNUP: "[XAuth] Ingreso por email",
    MAIL_REGISTRATION: "[XAuth] Registro Email",
    CANCEL: "[XAuth] Cancelar registro",
    LOGOUT: "[XAuth] Logout",
    AUTH_ERROR: "[XAuth] Error",
    REMOVE_USERS: "[XAuth] Remover",
};
var AddOnePublic = /** @class */ (function () {
    function AddOnePublic(payload) {
        this.payload = payload;
        this.type = ActionXPublicTypes.ADD_USER;
    }
    return AddOnePublic;
}());
if (false) {
    /** @type {?} */
    AddOnePublic.prototype.type;
    /** @type {?} */
    AddOnePublic.prototype.payload;
}
var UpsertManyPublic = /** @class */ (function () {
    function UpsertManyPublic(payload) {
        this.payload = payload;
        this.type = ActionXPublicTypes.UPSERT_MANY_PUBLIC;
    }
    return UpsertManyPublic;
}());
if (false) {
    /** @type {?} */
    UpsertManyPublic.prototype.type;
    /** @type {?} */
    UpsertManyPublic.prototype.payload;
}
var UpdatePublic = /** @class */ (function () {
    function UpdatePublic(uid, changes) {
        this.uid = uid;
        this.changes = changes;
        this.type = ActionXPublicTypes.UPDATE_PUBLIC;
    }
    return UpdatePublic;
}());
if (false) {
    /** @type {?} */
    UpdatePublic.prototype.type;
    /** @type {?} */
    UpdatePublic.prototype.uid;
    /** @type {?} */
    UpdatePublic.prototype.changes;
}
var UpdateAllPublic = /** @class */ (function () {
    function UpdateAllPublic(payload) {
        this.payload = payload;
        this.type = ActionXPublicTypes.UPDATE_ALL_PUBLIC;
    }
    return UpdateAllPublic;
}());
if (false) {
    /** @type {?} */
    UpdateAllPublic.prototype.type;
    /** @type {?} */
    UpdateAllPublic.prototype.payload;
}
var xGetUser = /** @class */ (function () {
    function xGetUser(payload) {
        this.payload = payload;
        this.type = ActionXPublicTypes.XGET_USER;
    }
    return xGetUser;
}());
if (false) {
    /** @type {?} */
    xGetUser.prototype.type;
    /** @type {?} */
    xGetUser.prototype.payload;
}
var IsNew = /** @class */ (function () {
    function IsNew(isNew) {
        this.isNew = isNew;
        this.type = ActionXPublicTypes.IS_NEW;
    }
    return IsNew;
}());
if (false) {
    /** @type {?} */
    IsNew.prototype.type;
    /** @type {?} */
    IsNew.prototype.isNew;
}
var Authenticated = /** @class */ (function () {
    function Authenticated(payload) {
        this.payload = payload;
        this.type = ActionXPublicTypes.AUTHENTICATED;
    }
    return Authenticated;
}());
if (false) {
    /** @type {?} */
    Authenticated.prototype.type;
    /** @type {?} */
    Authenticated.prototype.payload;
}
var NotAuthenticated = /** @class */ (function () {
    function NotAuthenticated() {
        this.type = ActionXPublicTypes.NOT_AUTHENTICATED;
    }
    return NotAuthenticated;
}());
if (false) {
    /** @type {?} */
    NotAuthenticated.prototype.type;
}
var AuthError = /** @class */ (function () {
    function AuthError(payload) {
        this.payload = payload;
        this.type = ActionXPublicTypes.AUTH_ERROR;
    }
    return AuthError;
}());
if (false) {
    /** @type {?} */
    AuthError.prototype.type;
    /** @type {?} */
    AuthError.prototype.payload;
}
////************************************************************
// Login actions
////************************************************************
/// Google Login
var 
////************************************************************
// Login actions
////************************************************************
/// Google Login
GoogleLogin = /** @class */ (function () {
    function GoogleLogin(payload) {
        this.payload = payload;
        this.type = ActionXPublicTypes.GOOGLE_LOGIN;
    }
    return GoogleLogin;
}());
if (false) {
    /** @type {?} */
    GoogleLogin.prototype.type;
    /** @type {?} */
    GoogleLogin.prototype.payload;
}
/// Facebook Login
var 
/// Facebook Login
SignInSocial = /** @class */ (function () {
    function SignInSocial(provider) {
        this.provider = provider;
        this.type = ActionXPublicTypes.SIGNINSOCIAL;
    }
    return SignInSocial;
}());
if (false) {
    /** @type {?} */
    SignInSocial.prototype.type;
    /** @type {?} */
    SignInSocial.prototype.provider;
}
/// Mail Login
var 
/// Mail Login
MailSignUp = /** @class */ (function () {
    function MailSignUp(payload) {
        this.payload = payload;
        this.type = ActionXPublicTypes.MAIL_SIGNUP;
    }
    return MailSignUp;
}());
if (false) {
    /** @type {?} */
    MailSignUp.prototype.type;
    /** @type {?} */
    MailSignUp.prototype.payload;
}
/// Mail Login
var 
/// Mail Login
MailRegistration = /** @class */ (function () {
    function MailRegistration() {
        this.type = ActionXPublicTypes.MAIL_REGISTRATION;
    }
    return MailRegistration;
}());
if (false) {
    /** @type {?} */
    MailRegistration.prototype.type;
}
/// Logout Actions
var 
/// Logout Actions
Logout = /** @class */ (function () {
    function Logout(payload) {
        this.payload = payload;
        this.type = ActionXPublicTypes.LOGOUT;
    }
    return Logout;
}());
if (false) {
    /** @type {?} */
    Logout.prototype.type;
    /** @type {?} */
    Logout.prototype.payload;
}
////************************************************************
// Login actions HELPERS
////************************************************************
var 
////************************************************************
// Login actions HELPERS
////************************************************************
Cancel = /** @class */ (function () {
    function Cancel(payload) {
        this.payload = payload;
        this.type = ActionXPublicTypes.CANCEL;
    }
    return Cancel;
}());
if (false) {
    /** @type {?} */
    Cancel.prototype.type;
    /** @type {?} */
    Cancel.prototype.payload;
}
var RemoveUsers = /** @class */ (function () {
    function RemoveUsers() {
        this.type = ActionXPublicTypes.REMOVE_USERS;
    }
    return RemoveUsers;
}());
if (false) {
    /** @type {?} */
    RemoveUsers.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/services/x-auth.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// import { AngularFirestore, AngularFireAuth } from '@angular/fire';
var XAuthService = /** @class */ (function () {
    function XAuthService(afAuth, store, afs, http) {
        this.afAuth = afAuth;
        this.store = store;
        this.afs = afs;
        this.http = http;
    }
    //********
    //**************** Public methods
    //********
    //== Registro con correo y contraseña
    //********
    //**************** Public methods
    //********
    //== Registro con correo y contraseña
    /**
     * @param {?} email
     * @param {?} password
     * @param {?} displayName
     * @return {?}
     */
    XAuthService.prototype.mailLogin = 
    //********
    //**************** Public methods
    //********
    //== Registro con correo y contraseña
    /**
     * @param {?} email
     * @param {?} password
     * @param {?} displayName
     * @return {?}
     */
    function (email, password, displayName) {
        return this.registryMail(email, password, displayName);
    };
    //== Inciar sesion con correo y contraseña
    //== Inciar sesion con correo y contraseña
    /**
     * @param {?} email
     * @param {?} password
     * @return {?}
     */
    XAuthService.prototype.signInWithEmailAndPassword = 
    //== Inciar sesion con correo y contraseña
    /**
     * @param {?} email
     * @param {?} password
     * @return {?}
     */
    function (email, password) {
        return from(this.signInWithEmail(email, password));
    };
    //********
    //**************** Helpers
    //*******
    //==	Enviar correo de verificacion
    //********
    //**************** Helpers
    //*******
    //==	Enviar correo de verificacion
    /**
     * @return {?}
     */
    XAuthService.prototype.sendEmailVerification = 
    //********
    //**************** Helpers
    //*******
    //==	Enviar correo de verificacion
    /**
     * @return {?}
     */
    function () {
        return this.sendVerification();
    };
    //==	Restablecer contraseña
    //==	Restablecer contraseña
    /**
     * @param {?} email
     * @return {?}
     */
    XAuthService.prototype.resetPassword = 
    //==	Restablecer contraseña
    /**
     * @param {?} email
     * @return {?}
     */
    function (email) {
        return from(this.resetPass(email));
    };
    //==	Restablecer envio de verificacioni de correo
    //==	Restablecer envio de verificacioni de correo
    /**
     * @return {?}
     */
    XAuthService.prototype.currentUserDataReload = 
    //==	Restablecer envio de verificacioni de correo
    /**
     * @return {?}
     */
    function () {
        if (this.afAuth.auth.currentUser) {
            return this.afAuth.auth.currentUser.reload();
        }
    };
    //==	Actualizar displayName despues del registro por correo
    //==	Actualizar displayName despues del registro por correo
    /**
     * @param {?} displayName
     * @param {?=} photoURL
     * @return {?}
     */
    XAuthService.prototype.updateProfileAuth = 
    //==	Actualizar displayName despues del registro por correo
    /**
     * @param {?} displayName
     * @param {?=} photoURL
     * @return {?}
     */
    function (displayName, photoURL) {
        return this.afAuth.auth.currentUser.updateProfile({
            displayName: displayName,
            photoURL: photoURL
        });
    };
    /**
     * userDelete
     */
    /**
     * userDelete
     * @return {?}
     */
    XAuthService.prototype.userDelete = /**
     * userDelete
     * @return {?}
     */
    function () {
        return this.currentUserDelete();
    };
    //==	Cerrar sesion
    //==	Cerrar sesion
    /**
     * @return {?}
     */
    XAuthService.prototype.signOut = 
    //==	Cerrar sesion
    /**
     * @return {?}
     */
    function () {
        return this.afAuth.auth.signOut();
    };
    /**
     * Buscar un usuario
     */
    /**
     * Buscar un usuario
     * @param {?} id
     * @return {?}
     */
    XAuthService.prototype.GetUserFires = /**
     * Buscar un usuario
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.getUserFirestoreMethod(id);
    };
    /**
     * Autenticar por medio de redes sociales
     */
    /**
     * Autenticar por medio de redes sociales
     * @param {?} provider
     * @return {?}
     */
    XAuthService.prototype.AutenticatedBySocialMethods = /**
     * Autenticar por medio de redes sociales
     * @param {?} provider
     * @return {?}
     */
    function (provider) {
        return this.socialSignIn(provider);
    };
    /**
     * Crear Usuario
     */
    /**
     * Crear Usuario
     * @param {?} Duser
     * @return {?}
     */
    XAuthService.prototype.createUserFirestore = /**
     * Crear Usuario
     * @param {?} Duser
     * @return {?}
     */
    function (Duser) {
        this.createUserFirestoreMethod(Duser);
    };
    /**
     * UpdateUserFire
     */
    /**
     * UpdateUserFire
     * @param {?} uid
     * @param {?} Duser
     * @return {?}
     */
    XAuthService.prototype.UpdateUserFire = /**
     * UpdateUserFire
     * @param {?} uid
     * @param {?} Duser
     * @return {?}
     */
    function (uid, Duser) {
        return this.updateUserFirestoreMethod(uid, Duser);
    };
    //Trae los campos de institucion
    //Trae los campos de institucion
    /**
     * @param {?} uid
     * @return {?}
     */
    XAuthService.prototype.getInstitucion = 
    //Trae los campos de institucion
    /**
     * @param {?} uid
     * @return {?}
     */
    function (uid) {
        return this.afs.collection("users").doc(uid).valueChanges().pipe(take(1));
    };
    //insert new institucion
    //insert new institucion
    /**
     * @param {?} uid
     * @param {?} school
     * @return {?}
     */
    XAuthService.prototype.insertNewInstitucion = 
    //insert new institucion
    /**
     * @param {?} uid
     * @param {?} school
     * @return {?}
     */
    function (uid, school) {
        /** @type {?} */
        var userRef = this.afs.collection("users").doc(uid);
        userRef.update({
            institucion: firestore.FieldValue.arrayUnion(school)
        });
    };
    /////****************/
    /////****************/
    //**************** Private method
    /////****************/
    /////****************/
    // buscar un usuario en firestore
    /////****************/
    /////****************/
    //**************** Private method
    /////****************/
    /////****************/
    // buscar un usuario en firestore
    /**
     * @private
     * @param {?} id
     * @return {?}
     */
    XAuthService.prototype.getUserFirestoreMethod = 
    /////****************/
    /////****************/
    //**************** Private method
    /////****************/
    /////****************/
    // buscar un usuario en firestore
    /**
     * @private
     * @param {?} id
     * @return {?}
     */
    function (id) {
        /** @type {?} */
        var data = this.afs.collection("users").doc("" + id).valueChanges();
        return data;
    };
    // crear un usuario firestore
    // crear un usuario firestore
    /**
     * @private
     * @param {?} Duser
     * @return {?}
     */
    XAuthService.prototype.createUserFirestoreMethod = 
    // crear un usuario firestore
    /**
     * @private
     * @param {?} Duser
     * @return {?}
     */
    function (Duser) {
        var displayName = Duser.displayName, email = Duser.email, identification = Duser.identification, phone = Duser.phone, photoURL = Duser.photoURL, theme = Duser.theme, typeIdentification = Duser.typeIdentification, uid = Duser.uid, roles = Duser.roles, createdAt = Duser.createdAt, lastLogins = Duser.lastLogins, institucion = Duser.institucion;
        //
        /** @type {?} */
        var _data = this.afs.collection("users").doc(Duser.uid).set({
            uid: uid,
            email: email,
            photoURL: photoURL,
            displayName: displayName,
            roles: roles,
            identification: identification,
            typeIdentification: typeIdentification,
            createdAt: createdAt,
            lastLogins: lastLogins,
            phone: phone,
            theme: theme,
            institucion: institucion,
        });
        return _data;
    };
    // actualizar un usuario firestore
    // actualizar un usuario firestore
    /**
     * @private
     * @param {?} uid
     * @param {?} Duser
     * @return {?}
     */
    XAuthService.prototype.updateUserFirestoreMethod = 
    // actualizar un usuario firestore
    /**
     * @private
     * @param {?} uid
     * @param {?} Duser
     * @return {?}
     */
    function (uid, Duser) {
        /** @type {?} */
        var _data = this.afs.collection("users").doc(uid).update(Duser);
        return _data;
    };
    // Proveedor de registro por mail
    // Proveedor de registro por mail
    /**
     * @private
     * @param {?} email
     * @param {?} password
     * @param {?} displayName
     * @return {?}
     */
    XAuthService.prototype.registryMail = 
    // Proveedor de registro por mail
    /**
     * @private
     * @param {?} email
     * @param {?} password
     * @param {?} displayName
     * @return {?}
     */
    function (email, password, displayName) {
        var _this = this;
        /** @type {?} */
        var registry = from(this.afAuth.auth.createUserWithEmailAndPassword(email, password).catch((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.store.dispatch(new AuthError(error));
        })))
        // Cancelar la subscripcion despues de la primera respuesta
        ;
        // Cancelar la subscripcion despues de la primera respuesta
        /** @type {?} */
        var send = registry.pipe(filter((/**
         * @param {?} data
         * @return {?}
         */
        function (data) { return !!data; })), 
        // take(1),
        catchError((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.store.dispatch(new AuthError(error));
            // retornar falso para terminar la emision
            return error;
        })));
        send.pipe(take(1)).subscribe();
        return send;
    };
    /**
     * @private
     * @param {?} provider
     * @return {?}
     */
    XAuthService.prototype.socialSignIn = /**
     * @private
     * @param {?} provider
     * @return {?}
     */
    function (provider) {
        var _this = this;
        /** @type {?} */
        var providers;
        switch (provider) {
            case "google":
                providers = new auth.GoogleAuthProvider();
                break;
            case "facebook":
                providers = new auth.FacebookAuthProvider();
                break;
            default:
                break;
        }
        return this.afAuth.auth.signInWithPopup(providers).catch((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.store.dispatch(new AuthError(error));
        }));
    };
    // // Proveedor de registro por google
    // protected registryGoogle() {
    // 	this.socialSignIn("google")
    // }
    // // Proveedor de registro por facebook
    // protected registryFacebook() {
    // 	this.socialSignIn("facebook")
    // }
    // Proveedor de inicio de sesion por mail
    // // Proveedor de registro por google
    // protected registryGoogle() {
    // 	this.socialSignIn("google")
    // }
    // // Proveedor de registro por facebook
    // protected registryFacebook() {
    // 	this.socialSignIn("facebook")
    // }
    // Proveedor de inicio de sesion por mail
    /**
     * @protected
     * @param {?} email
     * @param {?} password
     * @return {?}
     */
    XAuthService.prototype.signInWithEmail = 
    // // Proveedor de registro por google
    // protected registryGoogle() {
    // 	this.socialSignIn("google")
    // }
    // // Proveedor de registro por facebook
    // protected registryFacebook() {
    // 	this.socialSignIn("facebook")
    // }
    // Proveedor de inicio de sesion por mail
    /**
     * @protected
     * @param {?} email
     * @param {?} password
     * @return {?}
     */
    function (email, password) {
        var _this = this;
        return this.afAuth.auth.signInWithEmailAndPassword(email, password).catch((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.store.dispatch(new AuthError(error));
            return error;
        }));
    };
    // Envio de correo de comprobacion de registro
    // Envio de correo de comprobacion de registro
    /**
     * @protected
     * @return {?}
     */
    XAuthService.prototype.sendVerification = 
    // Envio de correo de comprobacion de registro
    /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        return this.afAuth.auth.currentUser.sendEmailVerification().catch((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.store.dispatch(new AuthError(error));
        }));
    };
    // Restablecer la contrasea
    // Restablecer la contrasea
    /**
     * @protected
     * @param {?} email
     * @return {?}
     */
    XAuthService.prototype.resetPass = 
    // Restablecer la contrasea
    /**
     * @protected
     * @param {?} email
     * @return {?}
     */
    function (email) {
        var _this = this;
        /** @type {?} */
        var fbAuth = this.afAuth.auth;
        return fbAuth.sendPasswordResetEmail(email).catch((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.store.dispatch(new AuthError(error));
            return error;
        }));
    };
    /**
     * @protected
     * @return {?}
     */
    XAuthService.prototype.currentUserDelete = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        return this.afAuth.auth.currentUser.delete().catch((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.store.dispatch(new AuthError(error));
        }));
    };
    /************/
    /// HELPERS
    /************/
    //******* VALIDA LOS DATOS DEL SERVIDOR
    /************/
    /// HELPERS
    /**
     * ********
     * @param {?} dataServe
     * @return {?}
     */
    //******* VALIDA LOS DATOS DEL SERVIDOR
    XAuthService.prototype.validateDataServer = /************/
    /// HELPERS
    /**
     * ********
     * @param {?} dataServe
     * @return {?}
     */
    //******* VALIDA LOS DATOS DEL SERVIDOR
    function (dataServe) {
        /** @type {?} */
        var compare = {
            uid: null,
            email: null,
            photoURL: null,
            displayName: null,
            roles: null,
            identification: null,
            typeIdentification: null,
            createdAt: null,
            lastLogins: null,
            phone: null,
            theme: null,
            institucion: null,
        };
        /**
         * @param {...?} objects
         * @return {?}
         */
        function objectsHaveSameKeys() {
            var objects = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                objects[_i] = arguments[_i];
            }
            /** @type {?} */
            var allKeys = objects.reduce((/**
             * @param {?} keys
             * @param {?} object
             * @return {?}
             */
            function (keys, object) { return keys.concat(Object.keys(object)); }), []);
            /** @type {?} */
            var union = new Set(allKeys);
            return objects.every((/**
             * @param {?} object
             * @return {?}
             */
            function (object) { return union.size === Object.keys(object).length; }));
        }
        return dataServe != undefined ? objectsHaveSameKeys(compare, dataServe) : false;
    };
    /**
     * getIpUser
     */
    /**
     * getIpUser
     * @return {?}
     */
    XAuthService.prototype.getIpUser = /**
     * getIpUser
     * @return {?}
     */
    function () {
        return this.http.get('https://api.ipify.org/?format=json&callback=get_ip').pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) { return data["ip"]; })), distinctUntilChanged());
    };
    XAuthService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    XAuthService.ctorParameters = function () { return [
        { type: AngularFireAuth },
        { type: Store },
        { type: AngularFirestore },
        { type: HttpClient }
    ]; };
    /** @nocollapse */ XAuthService.ngInjectableDef = ɵɵdefineInjectable({ factory: function XAuthService_Factory() { return new XAuthService(ɵɵinject(AngularFireAuth), ɵɵinject(Store), ɵɵinject(AngularFirestore), ɵɵinject(HttpClient)); }, token: XAuthService, providedIn: "root" });
    return XAuthService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    XAuthService.prototype.afAuth;
    /**
     * @type {?}
     * @private
     */
    XAuthService.prototype.store;
    /**
     * @type {?}
     * @private
     */
    XAuthService.prototype.afs;
    /** @type {?} */
    XAuthService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/services/actions.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActionsService = /** @class */ (function () {
    function ActionsService(store) {
        this.store = store;
        this.maxTime = 80000;
    }
    /**
     * AddOnePublicState
     */
    /**
     * AddOnePublicState
     * @param {?} state
     * @return {?}
     */
    ActionsService.prototype.AddOnePublicState = /**
     * AddOnePublicState
     * @param {?} state
     * @return {?}
     */
    function (state) {
        this.store.dispatch(new AddOnePublic(state));
    };
    /**
     * UpdateOnePublicState
     */
    /**
     * UpdateOnePublicState
     * @param {?} uid
     * @param {?} changes
     * @return {?}
     */
    ActionsService.prototype.UpdateOnePublicState = /**
     * UpdateOnePublicState
     * @param {?} uid
     * @param {?} changes
     * @return {?}
     */
    function (uid, changes) {
        this.store.dispatch(new UpdatePublic(uid, changes));
    };
    ActionsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root"
                },] }
    ];
    /** @nocollapse */
    ActionsService.ctorParameters = function () { return [
        { type: Store }
    ]; };
    /** @nocollapse */ ActionsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ActionsService_Factory() { return new ActionsService(ɵɵinject(Store)); }, token: ActionsService, providedIn: "root" });
    return ActionsService;
}());
if (false) {
    /** @type {?} */
    ActionsService.prototype.maxTime;
    /**
     * @type {?}
     * @private
     */
    ActionsService.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/services/helpers.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HelpersService = /** @class */ (function () {
    function HelpersService(actionsService, afAuth, XAuthService) {
        this.actionsService = actionsService;
        this.afAuth = afAuth;
        this.XAuthService = XAuthService;
    }
    // Crea un temporizador que actualiza el usuario
    // Ignora los primeros 10 segundos de emision, despues emite cada 2s
    // No encontre cobros en firebase por la recarga del usuario localmente,
    // sin embargo, es necesario verificar el rendimiento para el usuario, ¡y comprobar los cobros.
    // Crea un temporizador que actualiza el usuario
    // Ignora los primeros 10 segundos de emision, despues emite cada 2s
    // No encontre cobros en firebase por la recarga del usuario localmente,
    // sin embargo, es necesario verificar el rendimiento para el usuario, ¡y comprobar los cobros.
    /**
     * @return {?}
     */
    HelpersService.prototype.verifiMail = 
    // Crea un temporizador que actualiza el usuario
    // Ignora los primeros 10 segundos de emision, despues emite cada 2s
    // No encontre cobros en firebase por la recarga del usuario localmente,
    // sin embargo, es necesario verificar el rendimiento para el usuario, ¡y comprobar los cobros.
    /**
     * @return {?}
     */
    function () {
        var _this = this;
        return timer(10000, 2000).pipe(
        // Recargamos los datos del usuario
        map((/**
         * @return {?}
         */
        function () { return _this.XAuthService.currentUserDataReload(); })), 
        // tomamos los datos actualizados del usuario
        switchMap((/**
         * @return {?}
         */
        function () { return _this.afAuth.authState; })), takeWhile((/**
         * @param {?} data
         * @return {?}
         */
        function (data) { return !!data; })), 
        // Ignoramos la emision hasta que el correo sea verificado
        filter((/**
         * @param {?} authState
         * @return {?}
         */
        function (authState) { return authState.emailVerified === true; })), 
        // En este punto de la cadena, solo deberia llegar si el estado del usuario retorna algun valor,
        // pero en algunas ocaciones retorna otros valores, en tal caso retornamos verdadero para continuar la cadena
        map((/**
         * @return {?}
         */
        function () { return 'verified'; })), 
        // Tiempo limite, si no hemos obtenido respuesta emitimos para completar
        timeoutWith(this.actionsService.maxTime, of("Expired!")), catchError((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            return throwError(error);
        })));
    };
    /// Consultar errores de firebase https://firebase.google.com/docs/reference/js/firebase.auth.Auth?hl=es-419#signInWithPopup
    /// Consultar errores de firebase https://firebase.google.com/docs/reference/js/firebase.auth.Auth?hl=es-419#signInWithPopup
    /**
     * @param {?} error
     * @return {?}
     */
    HelpersService.prototype.errorTranslator = 
    /// Consultar errores de firebase https://firebase.google.com/docs/reference/js/firebase.auth.Auth?hl=es-419#signInWithPopup
    /**
     * @param {?} error
     * @return {?}
     */
    function (error) {
        /** @type {?} */
        var library = {
            'auth/email-already-in-use': 'Otro usuario ya está utilizando el correo electrónico proporcionado. Cada usuario debe tener un correo electrónico único.',
            'auth/invalid-email': 'Correo electrónico no es válido.',
            'auth/operation-not-allowed': 'Acción no autorizada.',
            'auth/weak-password': 'Contraseña no es suficientemente fuerte.',
            'auth/user-disabled': 'Correo electrónico ha sido deshabilitado.',
            'auth/user-not-found': 'Ningún usuario corresponde al correo electrónico ingresado.',
            'auth/wrong-password': 'La contraseña proporcionada no es valida, intenta nuevamente.',
            'auth/network-request-failed': 'Algo ha fallado, Revisa tu conexión a internet e intenta nuevamente.',
            'auth/popup-closed-by-user': 'Has cerrado la ventana antes de hacer el registro, intenta nuevamente.',
            'auth/invalid-display-name': 'El valor que se proporcionó para la propiedad de nombre. No debe estar vacío',
            'auth/email-already-exists': 'Otro usuario ya está utilizando el correo electrónico proporcionado. Cada usuario debe tener un correo electrónico único.',
            'auth/invalid-credential': 'La contraseña y/o correo proporcionado no son validos',
            'auth/insufficient-permission': 'No tienes permisos suficientes para acceder a esta sección',
            'auth/cancelled-popup-request': 'Solo se permite una solicitud a la vez',
            'auth/popup-blocked': 'La ventana emergente de autenticacion ha sido bloqueada por el navegador.',
            'auth/unauthorized-domain': 'Dominio no autorizado'
        };
        /** @type {?} */
        var keys = library[error];
        return keys != undefined ? keys : 'Error desconocido. Actualiza la ventana del navegador.';
    };
    HelpersService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    HelpersService.ctorParameters = function () { return [
        { type: ActionsService },
        { type: AngularFireAuth },
        { type: XAuthService }
    ]; };
    /** @nocollapse */ HelpersService.ngInjectableDef = ɵɵdefineInjectable({ factory: function HelpersService_Factory() { return new HelpersService(ɵɵinject(ActionsService), ɵɵinject(AngularFireAuth), ɵɵinject(XAuthService)); }, token: HelpersService, providedIn: "root" });
    return HelpersService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    HelpersService.prototype.actionsService;
    /**
     * @type {?}
     * @private
     */
    HelpersService.prototype.afAuth;
    /**
     * @type {?}
     * @private
     */
    HelpersService.prototype.XAuthService;
}
/**
 * Error de los formularios
 */
var /**
 * Error de los formularios
 */
MoocErrorMatcher = /** @class */ (function () {
    function MoocErrorMatcher() {
    }
    /**
     * @param {?} control
     * @param {?} form
     * @return {?}
     */
    MoocErrorMatcher.prototype.isErrorState = /**
     * @param {?} control
     * @param {?} form
     * @return {?}
     */
    function (control, form) {
        /** @type {?} */
        var isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    };
    return MoocErrorMatcher;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/user-form/user-form.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UserFormComponent = /** @class */ (function () {
    function UserFormComponent(fb, dialog, //modal aviso legal,
    store, Xsevice) {
        this.fb = fb;
        this.dialog = dialog;
        this.store = store;
        this.Xsevice = Xsevice;
        this.submit = new EventEmitter();
        this.unsubscribe$ = new Subject();
        this.errorMatcher = new MoocErrorMatcher();
        this.hide = true;
        this.hideConfirm = true;
        this.hideLogin = true;
        this.newUser = true; // to toggle login or signup form
    }
    /**
     * @return {?}
     */
    UserFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.buildForm();
    };
    /**
     * @return {?}
     */
    UserFormComponent.prototype.signup = /**
     * @return {?}
     */
    function () {
        this.Xsevice.mailLogin("" + this.userForm.value['email'], "" + this.userForm.value['password'], "" + this.userForm.value['displayName']);
        this.submit.emit();
        // this.auth.emailSignUp(this.userForm.value['displayName'], this.userForm.value['email'], this.userForm.value['password'])
    };
    /**
     * @return {?}
     */
    UserFormComponent.prototype.buildForm = /**
     * @return {?}
     */
    function () {
        this.userForm = this.fb.group({
            // 'displayName': ['', [
            // 	// Validators.required,
            // ]],
            'email': ['', [
                    Validators.required,
                    Validators.email,
                ]],
            'password': ['', [
                    Validators.required,
                    Validators.minLength(6),
                    Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[$@$!%*#?&])([a-zA-Z0-9$@$!%*#?&]+)$'),
                    Validators.maxLength(20),
                ]],
            'passwordConfirm': ['', [
                    this.equalto('password')
                ]],
        }, {
            validator: this.passwordValidator
        });
    };
    /**
     * @param {?} form
     * @return {?}
     */
    UserFormComponent.prototype.passwordValidator = /**
     * @param {?} form
     * @return {?}
     */
    function (form) {
        /** @type {?} */
        var condition = form.get('password').value !== form.get('passwordConfirm').value;
        return condition ? { passwordsDoNotMatch: true } : false;
    };
    /**
     * @param {?} field_name
     * @return {?}
     */
    UserFormComponent.prototype.equalto = /**
     * @param {?} field_name
     * @return {?}
     */
    function (field_name) {
        return (/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            /** @type {?} */
            var input = control.value;
            /** @type {?} */
            var isValid = control.root.value[field_name] == input;
            if (!isValid)
                return { 'equalTo': { isValid: isValid } };
            else
                return null;
        });
    };
    /**
     * @return {?}
     */
    UserFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    UserFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'area-user-form',
                    template: "<div class=\"form-container\">\n    <form [formGroup]=\"userForm\" (ngSubmit)=\"signup()\" autocomplete=\"off\" color=\"accent\">\n        <!-- Correo -->\n        <mat-form-field>\n            <input mat-focused matInput [errorStateMatcher]=\"errorMatcher\" placeholder=\"Correo electr\u00F3nico\" type=\"email\" formControlName=\"email\" required onCopy=\"return false\" onDrag=\"return false\" onDrop=\"return false\" onPaste=\"return false\">\n            <mat-error *ngIf=\"userForm.get('email').hasError('required')\">El correo electr\u00F3nico es requerido.\n            </mat-error>\n            <mat-error *ngIf=\"userForm.get('email').hasError('email')\">Correo electr\u00F3nico no valido.\n            </mat-error>\n        </mat-form-field>\n        <!-- contrase\u00F1a -->\n        <mat-form-field style=\"margin-bottom: 30px;\">\n            <input [errorStateMatcher]=\"errorMatcher\" matInput placeholder=\"Contrase\u00F1a\" [type]=\"hide ? 'password' : 'text'\" formControlName=\"password\" required onCopy=\"return false\" onDrag=\"return false\" onDrop=\"return false\" onPaste=\"return false\">\n            <mat-icon matSuffix class=\"cursor-pointer\" (click)=\"hide = !hide\">{{hide ? 'visibility' : 'visibility_off'}}\n            </mat-icon>\n            <mat-error *ngIf=\"userForm.get('password').hasError('required')\">La contrase\u00F1a es requerida.\n            </mat-error>\n            <mat-error *ngIf=\"userForm.get('password').hasError('pattern')\">Las contrase\u00F1as seguras deben tener al menos 6 caracteres, incluir letras, n\u00FAmeros y algunos de los siguientes caracteres especiales: ! # $ % & ? *</mat-error>\n        </mat-form-field>\n        <!-- confirmar contrase\u00F1a -->\n        <mat-form-field>\n            <input matInput placeholder=\"Confirmar la contrase\u00F1a\" [type]=\"hideConfirm ? 'password' : 'text'\" formControlName=\"passwordConfirm\" required onCopy=\"return false\" onDrag=\"return false\" onDrop=\"return false\" onPaste=\"return false\">\n            <mat-icon matSuffix class=\"cursor-pointer\" (click)=\"hideConfirm = !hideConfirm\">\n                {{hideConfirm ? 'visibility' : 'visibility_off'}}</mat-icon>\n            <mat-error *ngIf=\"userForm.hasError('passwordsDoNotMatch')\">Las contrase\u00F1as no coinciden.</mat-error>\n        </mat-form-field>\n        <button class=\"btn-form\" mat-flat-button color=\"primary\" type=\"submit\" [disabled]=\"!userForm.valid\">CREAR\n\t\t\tCUENTA</button>\n    </form>\n</div>",
                    styles: [":host form{padding:20px}:host .mat-form-field{width:100%;margin-bottom:15px}:host .btn-form{padding:5px 20px;border-radius:30px;margin:10px auto 0;display:block;transition:.7s;font-weight:700}:host .form-container{min-height:350px}"]
                }] }
    ];
    /** @nocollapse */
    UserFormComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: MatDialog },
        { type: Store },
        { type: XAuthService }
    ]; };
    UserFormComponent.propDecorators = {
        submit: [{ type: Output }]
    };
    return UserFormComponent;
}());
if (false) {
    /** @type {?} */
    UserFormComponent.prototype.submit;
    /**
     * @type {?}
     * @private
     */
    UserFormComponent.prototype.unsubscribe$;
    /** @type {?} */
    UserFormComponent.prototype.errorMatcher;
    /** @type {?} */
    UserFormComponent.prototype.hide;
    /** @type {?} */
    UserFormComponent.prototype.hideConfirm;
    /** @type {?} */
    UserFormComponent.prototype.hideLogin;
    /** @type {?} */
    UserFormComponent.prototype.userForm;
    /** @type {?} */
    UserFormComponent.prototype.newUser;
    /**
     * @type {?}
     * @private
     */
    UserFormComponent.prototype.fb;
    /** @type {?} */
    UserFormComponent.prototype.dialog;
    /**
     * @type {?}
     * @private
     */
    UserFormComponent.prototype.store;
    /**
     * @type {?}
     * @private
     */
    UserFormComponent.prototype.Xsevice;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/verified/verified.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VerifiedComponent = /** @class */ (function () {
    function VerifiedComponent(store, actionsService, dialogRef, helpers, XAuthService, inputData) {
        this.store = store;
        this.actionsService = actionsService;
        this.dialogRef = dialogRef;
        this.helpers = helpers;
        this.XAuthService = XAuthService;
        this.inputData = inputData;
        this.unsubscribe$ = new Subject();
        this.limitEmailVerified = 100000;
        this.cancelButton = 'No es mi correo';
        this.counter = false;
    }
    /**
     * @return {?}
     */
    VerifiedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.verifiedMail();
        // Limite de solicitud
        this.actionsService.maxTime = this.limitEmailVerified;
    };
    /**
     * @return {?}
     */
    VerifiedComponent.prototype.sendEmailVerification = /**
     * @return {?}
     */
    function () {
        this.verifiedMail();
    };
    /**
     * @return {?}
     */
    VerifiedComponent.prototype.restartAll = /**
     * @return {?}
     */
    function () {
        this.store.dispatch(new Cancel());
    };
    /**
     * @return {?}
     */
    VerifiedComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    /**
     * @return {?}
     */
    VerifiedComponent.prototype.verifiedMail = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var init = from(this.XAuthService.sendEmailVerification()).pipe(tap((/**
         * @return {?}
         */
        function () { return _this.counter = true; })), switchMap((/**
         * @return {?}
         */
        function () {
            //Emitir cada 2s hasta que el correo sea verificado
            return _this.helpers.verifiMail();
        })), tap((/**
         * @return {?}
         */
        function () { return _this.counter = false; })));
        init.pipe(takeUntil(this.unsubscribe$)).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data === "verified") {
                _this.store.dispatch(new xGetUser());
                _this.dialogRef.close();
            }
        }));
    };
    VerifiedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'area-verified',
                    template: "<section>\n\t<svg class=\"bac\" viewBox=\"0 0 149.16 45.5\">\n\t\t<path class=\"clsss-1\"\n\t\t\td=\"M13.29,28.73a21.79,21.79,0,0,1-1-8.87A21.37,21.37,0,0,1,18,7.22,22.49,22.49,0,0,1,36.23.09,22,22,0,0,1,56,24a18.55,18.55,0,0,1-.38,2.41,16.2,16.2,0,0,1,10.94,9.29,12.4,12.4,0,0,1,10.23.88A17.37,17.37,0,0,1,92.45,32a14.71,14.71,0,0,1,28.82,3.87,16.21,16.21,0,0,1,6.14,2.64c13.54-5,19.74,2.2,21.75,7H0A21.5,21.5,0,0,1,13.29,28.73Z\" />\n\t</svg>\n\t<div class=\"cont-v\">\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\">\n\t\t\t<rect class=\"cals-1\" width=\"19\" height=\"19\" />\n\t\t\t<path class=\"cals-2\"\n\t\t\t\td=\"M1.36,16.4s-.34-2,1.52-2a1.5,1.5,0,0,1,1.53,1.87,1.1,1.1,0,0,1,.85.51,1.64,1.64,0,0,1,.17,1.18C2,16.74.17,18.26.17,18.26A8.82,8.82,0,0,1,1.36,16.4Zm15.26.51.17-.85c-.33-2-2.2-1.36-2.54-1.19s-.51,1.36-.85,1.53-.34.68-.34.68a4.76,4.76,0,0,1,4.41,1.18C17.59,17.36,16.62,16.91,16.62,16.91Z\" />\n\t\t\t<path class=\"cals-2\"\n\t\t\t\td=\"M7.85,4v8.38H7V4A3.17,3.17,0,0,1,8.19,1.5l.36-.28a.74.74,0,0,1,.87,0h0l-.35.27A3.15,3.15,0,0,0,7.85,4Z\" />\n\t\t\t<path class=\"cals-3\"\n\t\t\t\td=\"M11.42,1.42a.68.68,0,1,1,.68.68A.67.67,0,0,1,11.42,1.42Zm-5,6.47-.4.53a8.13,8.13,0,0,1-.91,1,1.92,1.92,0,0,0-.58,1.37v1.29H6.45Zm6.9,2.91a1.93,1.93,0,0,0-.59-1.37,9,9,0,0,1-.91-1l-.39-.53v4.2h1.89Zm.2-5.09a.3.3,0,1,0-.3.29A.3.3,0,0,0,13.55,5.71ZM9,7.89a.43.43,0,1,0-.42-.42A.42.42,0,0,0,9,7.89Zm-4.33.18a.3.3,0,1,0-.29-.29A.29.29,0,0,0,4.65,8.07ZM3.52,6.44a.3.3,0,1,0,.3.3A.3.3,0,0,0,3.52,6.44ZM9,4.57a.43.43,0,0,0,0,.85.43.43,0,1,0,0-.85Zm0,5.79a.43.43,0,1,0-.42-.42A.42.42,0,0,0,9,10.36Z\" />\n\t\t\t<path class=\"cals-4\"\n\t\t\t\td=\"M15.34,14.21a1.87,1.87,0,0,0-1.84,1.7,1.34,1.34,0,0,0-.61.38,1.7,1.7,0,0,0-1.83.21,1.42,1.42,0,0,0-.56-.18A1.27,1.27,0,0,0,8,16.22a1.51,1.51,0,0,0-1.32.53,1.06,1.06,0,0,0-.89,0,1.42,1.42,0,0,0-1-.72,1.48,1.48,0,0,0,0-.21,1.86,1.86,0,0,0-1.9-1.9A1.81,1.81,0,0,0,1,15.83a2,2,0,0,0,.16.76,1.88,1.88,0,0,0-1,1.67A2.86,2.86,0,0,1,2,16.91c.1,0-.24-.34-.24-.34a1.3,1.3,0,1,1,2.38-.74,1.32,1.32,0,0,1-.07.42L4,16.71l.48-.07a.82.82,0,0,1,.91.65l.11.65.41-.51a.47.47,0,0,1,.68-.05l.29.26L7,17.3a.91.91,0,0,1,1.15-.42l.48.18-.08-.52v-.08a.68.68,0,1,1,1.35,0,.49.49,0,0,1,0,.12L9.83,17l.41-.07h.12a.81.81,0,0,1,.53.2l.22.19.2-.22a1.12,1.12,0,0,1,1.48-.16l.27.2.17-.28a.81.81,0,0,1,.6-.4l.28,0v-.35a1.25,1.25,0,0,1,2.5,0,1.27,1.27,0,0,1-.25.75s-.26.24-.18.24c1,0,1.36,1.21,1.36,1.21A1.9,1.9,0,0,0,17,16.93a1.87,1.87,0,0,0,.22-.87A1.91,1.91,0,0,0,15.34,14.21Z\" />\n\t\t\t<path class=\"cals-5\"\n\t\t\t\td=\"M4.55,2.9A.49.49,0,1,1,5,3.38.49.49,0,0,1,4.55,2.9Zm9.72,2a.48.48,0,1,0-.47-.47A.47.47,0,0,0,14.27,4.9ZM10,9.94a1,1,0,1,1-1-1A1,1,0,0,1,10,9.94Zm-.57,0a.43.43,0,1,0-.85,0,.43.43,0,0,0,.85,0ZM10.66,2a2.43,2.43,0,0,0-.2-.25L10,2.13l.16.2ZM10,7.47a1,1,0,1,1-1-1A1,1,0,0,1,10,7.47Zm-.57,0a.43.43,0,1,0-.85,0,.43.43,0,0,0,.85,0ZM10,5A1,1,0,1,1,9,4,1,1,0,0,1,10,5ZM9.41,5A.43.43,0,1,0,9,5.42.42.42,0,0,0,9.41,5ZM6.68,12.66H4V10.8A2.55,2.55,0,0,1,4.74,9a7.64,7.64,0,0,0,.86-.93L6.68,6.62V4A3.44,3.44,0,0,1,8,1.28L8.38,1A1,1,0,0,1,9.59,1l.4.3-.35.45-.4-.3a.42.42,0,0,0-.52,0l-.36.28A2.88,2.88,0,0,0,7.25,4v8.09h3.47V4a2.91,2.91,0,0,0-.28-1.23L11,2.48A3.45,3.45,0,0,1,11.29,4V6.71l1,1.38a7.57,7.57,0,0,0,.85.93,2.51,2.51,0,0,1,.75,1.78v1.86H6.68Zm4.78-.57h1.89V10.8a1.93,1.93,0,0,0-.59-1.37,9,9,0,0,1-.91-1l-.39-.53Zm-5-4.2-.4.53a8.13,8.13,0,0,1-.91,1,1.92,1.92,0,0,0-.58,1.37v1.29H6.45ZM18.15,14a.85.85,0,1,0,.85.85A.85.85,0,0,0,18.15,14Zm0,1.19a.34.34,0,1,1,.34-.34A.34.34,0,0,1,18.15,15.21ZM.59,12.84a.59.59,0,1,0,.6.59A.59.59,0,0,0,.59,12.84Zm0,.83a.24.24,0,0,1,0-.48.24.24,0,0,1,0,.48Z\" />\n\t\t</svg>\n\t\t<h1>Verifica tu correo electr\u00F3nico</h1>\n\t\t<ng-container *ngIf=\"counter\">\n\t\t\t<p>Hemos enviado un correo a <strong>{{inputData.data.email}}</strong></p>\n\t\t</ng-container>\n\t\t<div class=\"btns-validate\">\n\t\t\t<button mat-stroked-button [disabled]=\"counter\" (click)=\"sendEmailVerification()\">Enviar nuevamente\n\t\t\t\t<area-number-tracker *ngIf=\"counter\" [end]=\"limitEmailVerified\"></area-number-tracker>\n\t\t\t</button>\n\t\t\t<button mat-stroked-button (click)=\"restartAll()\">{{cancelButton}}</button>\n\t\t</div>\n\t</div>\n</section>",
                    styles: ["@media (orientation:landscape){.movil{display:inherit}.desktop{display:none}}section{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}section .cont-v{max-width:400px;position:absolute;padding:20px}section .btns-validate button{margin:5px;padding:5px 15px;border-radius:30px}.cals-1{fill:none}.cals-2,.cals-3,.cals-4,.cals-5{fill:#323753}.cals-2{opacity:.1}.cals-3{opacity:.35}.cals-5{opacity:.9}svg{width:120px;height:auto}.clsss-1{fill:#9eb1be;opacity:.05}.bac{width:120%;height:auto;position:fixed;bottom:0;left:0}@media (max-width:768px){.bac{width:322%;left:-100%}}"]
                }] }
    ];
    /** @nocollapse */
    VerifiedComponent.ctorParameters = function () { return [
        { type: Store },
        { type: ActionsService },
        { type: MatDialogRef },
        { type: HelpersService },
        { type: XAuthService },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
    ]; };
    return VerifiedComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    VerifiedComponent.prototype.unsubscribe$;
    /** @type {?} */
    VerifiedComponent.prototype.limitEmailVerified;
    /** @type {?} */
    VerifiedComponent.prototype.cancelButton;
    /** @type {?} */
    VerifiedComponent.prototype.counter;
    /**
     * @type {?}
     * @private
     */
    VerifiedComponent.prototype.store;
    /**
     * @type {?}
     * @private
     */
    VerifiedComponent.prototype.actionsService;
    /**
     * @type {?}
     * @private
     */
    VerifiedComponent.prototype.dialogRef;
    /**
     * @type {?}
     * @private
     */
    VerifiedComponent.prototype.helpers;
    /**
     * @type {?}
     * @private
     */
    VerifiedComponent.prototype.XAuthService;
    /** @type {?} */
    VerifiedComponent.prototype.inputData;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/services/xmodal.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var XmodalService = /** @class */ (function () {
    function XmodalService(dialog) {
        this.dialog = dialog;
    }
    /**
     * @return {?}
     */
    XmodalService.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.dialog.closeAll();
    };
    /**
     * @param {?} data
     * @return {?}
     */
    XmodalService.prototype.openModal = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        // this.courseService.playPauseService.next("pause");
        // this.courseService.playPauseService.next("pause");
        /** @type {?} */
        var dialogRef = this.dialog.open(VerifiedComponent, {
            data: {
                data: data
            },
            minWidth: "100%",
            minHeight: "100%",
            width: "100%",
            height: "100%",
            hasBackdrop: true,
            disableClose: true,
            closeOnNavigation: false
        });
        return dialogRef.afterClosed();
    };
    XmodalService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root"
                },] }
    ];
    /** @nocollapse */
    XmodalService.ctorParameters = function () { return [
        { type: MatDialog }
    ]; };
    /** @nocollapse */ XmodalService.ngInjectableDef = ɵɵdefineInjectable({ factory: function XmodalService_Factory() { return new XmodalService(ɵɵinject(MatDialog$1)); }, token: XmodalService, providedIn: "root" });
    return XmodalService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    XmodalService.prototype.dialog;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/effects/xuser.effects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var XUserEffects = /** @class */ (function () {
    function XUserEffects(store, actionsService, actions$, afAuth, XAuthService, router, _snackBar, xmodal, helpers) {
        var _this = this;
        this.store = store;
        this.actionsService = actionsService;
        this.actions$ = actions$;
        this.afAuth = afAuth;
        this.XAuthService = XAuthService;
        this.router = router;
        this._snackBar = _snackBar;
        this.xmodal = xmodal;
        this.helpers = helpers;
        this.stateGetUserFinalize$ = new BehaviorSubject({});
        this.unsubscribe$ = new Subject();
        this.initial = {
            mailVerifyIsWait: false,
            isNew: false,
            isAuthenticated: false
        };
        // ngrxOnInitEffects() {
        // 	// console.log("init effects")
        // 	return { type: '[EffectWithInitAction] Init' };
        // }
        //========================================
        // Buscar usuario
        //========================================
        this.getUser$ = this.actions$.pipe(ofType(ActionXPublicTypes.XGET_USER), 
        // Obtener los datos de autenticacion de proveedor, almacenados local
        switchMap((/**
         * @return {?}
         */
        function () { return _this.afAuth.authState; })), 
        // Consultar datos del servidor y validarlos
        switchMap((/**
         * @param {?} _authData
         * @return {?}
         */
        function (_authData) {
            //****** Si retorna datos de autenticacion, verificarlos, de lo contrario retornar null
            return _authData
                ? _this.XAuthService.GetUserFires(_authData.uid).pipe(map((/**
                 * @param {?} _dataServe
                 * @return {?}
                 */
                function (_dataServe) {
                    // Valida los datos del usuario, retornara el state y payload
                    // state: estado actual del usuario con base en el registro y los datos del servidor
                    //  ---- emailVerified: SI el usuario aun no ha verificado el correo electronico
                    //  ---- isNew: Si es nuevo
                    //  ---- valid: Cuando los datos del usuario posee datos correctos guardados en el servidor
                    return _this.verifiedDataUser(_authData, _dataServe);
                })), 
                // Cancelar la subscripcion cuando se reciban datos validos del servidor
                /// PIPE personalizado basado en takeWhile, para lograr cancelar la subscripcion y emitir el ultimo valor
                // rxjs6.4+ permite emitir el ultimo valos despues de la cancelacion
                completeWith((/**
                 * @param {?} _result
                 * @return {?}
                 */
                function (_result) { return _result.state != 'valid'; })))
                : of({ state: "notAuthenticated", payload: null });
        })), tap((/**
         * @param {?} _result
         * @return {?}
         */
        function (_result) {
            switch (_result.state) {
                // Si el correo esta por verificar
                case "emailVerified":
                    // Abrir modal de verificacion de email
                    _this.xmodal.openModal(_result.payload);
                    break;
                //  Si es un usuario nuevo
                case "isNew":
                    // Si el usuario es nuevo,
                    var _a = _result.payload, uid = _a.uid, displayName = _a.displayName, email = _a.email, photoURL = _a.photoURL;
                    // si el usuario es nuevo se emitira a los subscriptores los datos del usuario,
                    // este estado seria el indicado para recopilar nuevos datos del usuario
                    _this.store.dispatch(new IsNew({
                        current: true,
                        payload: { uid: uid, displayName: displayName, email: email, photoURL: photoURL }
                    }));
                    break;
                // si es valido
                case "valid":
                    _this.institucion = window.location.origin;
                    if (_this.institucion.includes('5000') || _this.institucion.includes('sanmarcos')) {
                        _this.institucion = "sanmarcos";
                    }
                    _this.XAuthService.UpdateUserFire(_result.payload.uid, {
                        lastLogins: _this.newLoginUpdate(_result.payload.lastLogins, _this.ipAdress, _this.institucion)
                    });
                    _this.validUserRegister(_result.payload.uid);
                    break;
                default:
                    break;
            }
        })), 
        // Filtar, solo resultados validos o no autenticado
        filter((/**
         * @param {?} _result
         * @return {?}
         */
        function (_result) {
            return _result.state === "valid" || _result.state === "notAuthenticated";
        })), mergeMap((/**
         * @param {?} authData
         * @return {?}
         */
        function (authData) {
            return iif((/**
             * @return {?}
             */
            function () { return authData.state === "valid"; }), of(new Authenticated(authData.payload)), of(new NotAuthenticated()));
        })));
        //========================================
        // Authenticated
        //========================================
        this.authenticated$ = this.actions$.pipe(ofType(ActionXPublicTypes.AUTHENTICATED), tap((/**
         * @param {?} _data
         * @return {?}
         */
        function (_data) { return _this.actionsService.AddOnePublicState(_data.payload); })), tap((/**
         * @param {?} _data
         * @return {?}
         */
        function (_data) {
            // this.router.navigate(["escritorio"]);
            _this.snackBarOpen("Bienvenido a MOOC");
        })));
        //========================================
        // Ingreso Social
        //========================================
        this.signInSocial$ = this.actions$.pipe(ofType(ActionXPublicTypes.SIGNINSOCIAL), 
        //Prevenir que el usuario abra el modal despues de 3s desde el ultimo evento
        throttleTime(3000), 
        // Convertimos la promesa devuelta por el provedor en un observable y cancelamos la emision cuando se complete
        // swithMap: En cada emisión, el observable interno anterior (el resultado de la función que proporcionó) se cancela y se suscribe el nuevo observable.
        switchMap((/**
         * @param {?} payload
         * @return {?}
         */
        function (payload) {
            return from(_this.XAuthService.AutenticatedBySocialMethods(payload.provider));
        })), 
        // Completar cuando el resultado de registro retorne algun valor
        // Al cancelar la subscripcion, si el usuario cierra sesion, no podra ingresar nuevamente, si no refrezca la pagina
        // takeWhile(credential => credential === null || credential == undefined),
        map((/**
         * @return {?}
         */
        function () {
            _this.router.navigate(["cursos/escritorio"]);
            return new xGetUser();
        })));
        //========================================
        // Cancelar registro
        //========================================
        this.cancel$ = this.actions$.pipe(ofType(ActionXPublicTypes.CANCEL), switchMap((/**
         * @param {?} _
         * @return {?}
         */
        function (_) { return _this.XAuthService.userDelete(); })), tap((/**
         * @return {?}
         */
        function () {
            _this.logoutUpdate();
            _this.xmodal.closeModal();
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.snackBarOpen("Registro cancelado");
            }), 2000);
        })), catchError((/**
         * @param {?} error
         * @return {?}
         */
        function (error) { return of(new AuthError(error)); })));
        //========================================
        // Logout
        //========================================
        this.logout$ = this.actions$.pipe(ofType(ActionXPublicTypes.LOGOUT), tap((/**
         * @return {?}
         */
        function () {
            _this.logoutUpdate();
            _this.router.navigate([""]);
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.snackBarOpen("Cerraste sesión correctamente");
            }), 1000);
        })), map((/**
         * @return {?}
         */
        function () { return new xGetUser(); })));
        //========================================
        // Error
        //========================================
        this.xAuthError$ = this.actions$.pipe(ofType(ActionXPublicTypes.AUTH_ERROR), map((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this._snackBar.open(_this.helpers.errorTranslator(error.payload.code), "Entendido", {
                duration: 10000,
                horizontalPosition: "right"
            });
        })));
        this.XAuthService.getIpUser().pipe(take(1)).subscribe((/**
         * @param {?} _ip
         * @return {?}
         */
        function (_ip) {
            _this.ipAdress = _ip;
        }));
    }
    ///////////////////////////////
    //VALIDATE USER REGISTRED
    ///////////////////////////////
    ///////////////////////////////
    //VALIDATE USER REGISTRED
    ///////////////////////////////
    /**
     * @private
     * @param {?} uid
     * @return {?}
     */
    XUserEffects.prototype.validUserRegister = 
    ///////////////////////////////
    //VALIDATE USER REGISTRED
    ///////////////////////////////
    /**
     * @private
     * @param {?} uid
     * @return {?}
     */
    function (uid) {
        var _this = this;
        /** @type {?} */
        var domain = window.location.origin;
        /** @type {?} */
        var currentSchool = '';
        if (domain.includes('sanmarcos') || domain.includes('5000')) {
            //console.log('domain is sanmarcos')
            currentSchool = 'sanmarcos';
        }
        else if (domain.includes('istmo') || domain.includes('5500')) {
            //console.log('domain es itsmo');
            currentSchool = 'istmo';
        }
        else if (domain.includes('areandina') || domain.includes('4200') || domain.includes('mirror-mooc-233515')) {
            //console.log('domain es andina');
            currentSchool = 'areandina';
        }
        /** @type {?} */
        var schoolRegistred = this.XAuthService.getInstitucion(uid);
        //console.log("schoolRegistred");
        schoolRegistred.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            res['institucion'].forEach((/**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                // console.log(v)
                if (currentSchool != v) {
                    // console.log('insert')
                    _this.XAuthService.insertNewInstitucion(uid, currentSchool);
                }
                else {
                    // console.log('ok');
                }
            }));
        }));
    };
    ///*************************************
    ///*************************************
    //// FUNCTIONS
    ///*************************************
    ///*************************************
    //******* VALIDA LOS DATOS DEL USUARIO ANTES DEL REGIsTRO
    ///*************************************
    ///*************************************
    //// FUNCTIONS
    ///*************************************
    ///*************************************
    //******* VALIDA LOS DATOS DEL USUARIO ANTES DEL REGIsTRO
    /**
     * @private
     * @param {?} authData
     * @param {?} dataServe
     * @return {?}
     */
    XUserEffects.prototype.verifiedDataUser = 
    ///*************************************
    ///*************************************
    //// FUNCTIONS
    ///*************************************
    ///*************************************
    //******* VALIDA LOS DATOS DEL USUARIO ANTES DEL REGIsTRO
    /**
     * @private
     * @param {?} authData
     * @param {?} dataServe
     * @return {?}
     */
    function (authData, dataServe) {
        // Si los UID son iguales
        /** @type {?} */
        var uidIsEqual = authData.uid === (dataServe ? dataServe.uid : "");
        // Si el correo fue verificado
        /** @type {?} */
        var emailVerified = authData.emailVerified;
        // Si falta algun dato de usuario en el servidor
        /** @type {?} */
        var dataServeIsValid = this.XAuthService.validateDataServer(dataServe);
        // Actualmente solo compara los datos en el servidor
        // Si es nuevo
        /** @type {?} */
        var isNew = !dataServeIsValid ? true : false;
        // Si esta registrado
        /** @type {?} */
        var isAuthenticated = authData != null;
        // SI ESTA VALIDO
        if (dataServeIsValid && uidIsEqual && emailVerified)
            return {
                state: "valid",
                payload: __assign({}, dataServe, { isAuthenticated: true })
            };
        // SI ES NUEVO
        if (!!isNew && emailVerified)
            return { state: "isNew", payload: authData };
        // SI EL EMAIL ES VERIFICADO
        if (!emailVerified) {
            return { state: "emailVerified", payload: authData };
        }
    };
    ////// Snack bar
    ////// Snack bar
    /**
     * @private
     * @param {?} message
     * @return {?}
     */
    XUserEffects.prototype.snackBarOpen = 
    ////// Snack bar
    /**
     * @private
     * @param {?} message
     * @return {?}
     */
    function (message) {
        this._snackBar.open(message, "Entendido", {
            horizontalPosition: "right",
            duration: 5000,
        });
    };
    //////
    //////
    /**
     * @private
     * @param {?} lastLogins
     * @param {?} ip
     * @param {?} institucion
     * @return {?}
     */
    XUserEffects.prototype.newLoginUpdate = 
    //////
    /**
     * @private
     * @param {?} lastLogins
     * @param {?} ip
     * @param {?} institucion
     * @return {?}
     */
    function (lastLogins, ip, institucion) {
        /** @type {?} */
        var timeNow = new Date();
        /** @type {?} */
        var newTime = { ipAddress: ip || 'null', loginAt: timeNow, institucion: institucion };
        /** @type {?} */
        var limit = 10;
        /** @type {?} */
        var bucket = lastLogins;
        if (bucket.length == limit - 1)
            bucket.shift();
        if (bucket.length < limit)
            bucket.push(newTime);
        return bucket;
    };
    //***** restaurar los valores para el usuario
    //***** restaurar los valores para el usuario
    /**
     * @private
     * @return {?}
     */
    XUserEffects.prototype.logoutUpdate = 
    //***** restaurar los valores para el usuario
    /**
     * @private
     * @return {?}
     */
    function () {
        this.XAuthService.signOut();
        this.store.dispatch(new RemoveUsers());
    };
    XUserEffects.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    XUserEffects.ctorParameters = function () { return [
        { type: Store },
        { type: ActionsService },
        { type: Actions },
        { type: AngularFireAuth },
        { type: XAuthService },
        { type: Router },
        { type: MatSnackBar },
        { type: XmodalService },
        { type: HelpersService }
    ]; };
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], XUserEffects.prototype, "getUser$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], XUserEffects.prototype, "authenticated$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], XUserEffects.prototype, "signInSocial$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], XUserEffects.prototype, "cancel$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], XUserEffects.prototype, "logout$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], XUserEffects.prototype, "xAuthError$", void 0);
    return XUserEffects;
}());
if (false) {
    /** @type {?} */
    XUserEffects.prototype.stateGetUserFinalize$;
    /**
     * @type {?}
     * @private
     */
    XUserEffects.prototype.unsubscribe$;
    /** @type {?} */
    XUserEffects.prototype.institucion;
    /** @type {?} */
    XUserEffects.prototype.initial;
    /** @type {?} */
    XUserEffects.prototype.getUser$;
    /** @type {?} */
    XUserEffects.prototype.authenticated$;
    /** @type {?} */
    XUserEffects.prototype.signInSocial$;
    /** @type {?} */
    XUserEffects.prototype.cancel$;
    /** @type {?} */
    XUserEffects.prototype.logout$;
    /** @type {?} */
    XUserEffects.prototype.xAuthError$;
    /** @type {?} */
    XUserEffects.prototype.ipAdress;
    /**
     * @type {?}
     * @private
     */
    XUserEffects.prototype.store;
    /**
     * @type {?}
     * @private
     */
    XUserEffects.prototype.actionsService;
    /**
     * @type {?}
     * @private
     */
    XUserEffects.prototype.actions$;
    /**
     * @type {?}
     * @private
     */
    XUserEffects.prototype.afAuth;
    /**
     * @type {?}
     * @private
     */
    XUserEffects.prototype.XAuthService;
    /**
     * @type {?}
     * @private
     */
    XUserEffects.prototype.router;
    /**
     * @type {?}
     * @private
     */
    XUserEffects.prototype._snackBar;
    /**
     * @type {?}
     * @private
     */
    XUserEffects.prototype.xmodal;
    /**
     * @type {?}
     * @private
     */
    XUserEffects.prototype.helpers;
}
/// PIPE personalizado basado en takeWhile, para lograr cancelar la subscripcion y emitir el ultimo valor
// rxjs6.4+ permite emitir el ultimo valos despues de la cancelacion
/**
 * @template T
 * @param {?} predicate
 * @return {?}
 */
function completeWith(predicate) {
    return (/**
     * @param {?} source
     * @return {?}
     */
    function (source) {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        function (observer) {
            return source.subscribe({
                next: /**
                 * @param {?} x
                 * @return {?}
                 */
                function (x) {
                    /** @type {?} */
                    var shouldContinue;
                    try {
                        shouldContinue = predicate(x);
                    }
                    catch (err) {
                        observer.error(err);
                        return;
                    }
                    observer.next(x);
                    if (!shouldContinue) {
                        observer.complete();
                    }
                },
                error: /**
                 * @param {?} err
                 * @return {?}
                 */
                function (err) { observer.error(err); },
                complete: /**
                 * @return {?}
                 */
                function () { observer.complete(); }
            });
        }));
    });
}

var _a;
/**
 * @record
 */
function XPublicState() { }
if (false) {
    /** @type {?} */
    XPublicState.prototype.isNew;
}
var ɵ0 = /**
 * @param {?} x
 * @return {?}
 */
function (x) { return x.uid; };
/** @type {?} */
var XPublicAdapter = createEntityAdapter({
    // sortComparer: sortByCourseAndSeqNo,
    selectId: (ɵ0)
});
/** @type {?} */
var initial = {
    mailVerifyIsWait: false,
    displayName: "GUEST",
    uid: "user",
    email: "",
    emailVerified: false,
    isAuthenticated: false,
    isNew: false,
    state: 'initial',
    connect: false,
    error: {
        code: '',
        message: '',
        id: 'error'
    }
};
/** @type {?} */
var initialState = XPublicAdapter.getInitialState({
    isNew: false
});
/**
 * @param {?=} state
 * @param {?=} action
 * @return {?}
 */
function ActionsXPublicReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionXPublicTypes.XGET_USER:
            return action.payload, state;
        // case ActionXPublicTypes.NOT_AUTHENTICATED:
        // case ActionXPublicTypes.GOOGLE_LOGIN:
        // case ActionXPublicTypes.FACEBOOK_LOGIN:
        // case ActionXPublicTypes.MAIL_SIGNUP:
        // case ActionXPublicTypes.MAIL_VERIFY:
        // case ActionXPublicTypes.AUTH_ERROR:
        // case ActionXPublicTypes.CANCEL:
        // case ActionXPublicTypes.LOGOUT:
        // 	return state;
        case ActionXPublicTypes.IS_NEW:
            return __assign({}, state, { isNew: action.isNew });
        case ActionXPublicTypes.AUTH_ERROR:
            return action.payload, state;
        case ActionXPublicTypes.ADD_USER:
            return XPublicAdapter.upsertOne(action.payload, state);
        case ActionXPublicTypes.AUTHENTICATED:
            return action.payload, state;
        case ActionXPublicTypes.UPDATE_PUBLIC:
            return XPublicAdapter.updateOne({
                id: action.uid,
                changes: action.changes,
            }, state);
        case ActionXPublicTypes.UPDATE_ALL_PUBLIC: {
            return XPublicAdapter.updateMany(action.payload, state);
        }
        case ActionXPublicTypes.UPSERT_MANY_PUBLIC: {
            return XPublicAdapter.upsertMany(action.payload, state);
        }
        case ActionXPublicTypes.REMOVE_USERS: {
            return XPublicAdapter.removeAll(state);
        }
        default:
            return state;
    }
}
var selectIds = (_a = XPublicAdapter.getSelectors(), _a.selectIds), selectEntities = _a.selectEntities, selectAll = _a.selectAll, selectTotal = _a.selectTotal;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/xuser.selectors.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var selectPublicState = createFeatureSelector("xpublic");
var ɵ0$1 = /**
 * @param {?} iswait
 * @return {?}
 */
function (iswait) { return iswait.entities['mailVerifyIsWait'].state; };
/** @type {?} */
var SelectmailVerifyIsWait = createSelector(selectPublicState, (ɵ0$1));
/** @type {?} */
var SelectAllUser = createSelector(selectPublicState, selectAll);
var ɵ1 = /**
 * @param {?} isnew
 * @return {?}
 */
function (isnew) { return isnew.isNew; };
/** @type {?} */
var isNew = createSelector(selectPublicState, (ɵ1));
var ɵ2 = /**
 * @param {?} states
 * @return {?}
 */
function (states) {
    var _a = __read(states, 1), _value = _a[0];
    return _value;
};
/** @type {?} */
var SelectPublic = createSelector(SelectAllUser, (ɵ2));
var ɵ3 = /**
 * @param {?} states
 * @return {?}
 */
function (states) {
    var _a = __read(states, 1), _value = _a[0];
    if (_value)
        return _value.isAuthenticated;
};
/** @type {?} */
var isAuthenticated = createSelector(SelectAllUser, (ɵ3));
var ɵ4 = /**
 * @param {?} state
 * @return {?}
 */
function (state) { return state.error; };
/** @type {?} */
var ErrorSelector = createSelector(selectPublicState, (ɵ4));
var ɵ5 = /**
 * @param {?} state
 * @return {?}
 */
function (state) { return state; };
/** @type {?} */
var UserSelector = createSelector(selectPublicState, (ɵ5));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/user-login/user-login.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UserLoginComponent = /** @class */ (function () {
    function UserLoginComponent(store, service) {
        this.store = store;
        this.service = service;
        this.spinner = false;
    }
    // user$: Observable<xUser>;
    /// Social Login
    // signInWithGoogle() {
    // 	this.store.dispatch(new SignInSocial("google"));
    // }
    // user$: Observable<xUser>;
    /// Social Login
    // signInWithGoogle() {
    // 	this.store.dispatch(new SignInSocial("google"));
    // }
    /**
     * @return {?}
     */
    UserLoginComponent.prototype.registryFacebook = 
    // user$: Observable<xUser>;
    /// Social Login
    // signInWithGoogle() {
    // 	this.store.dispatch(new SignInSocial("google"));
    // }
    /**
     * @return {?}
     */
    function () {
        this.store.dispatch(new SignInSocial("facebook"));
    };
    /**
     * @return {?}
     */
    UserLoginComponent.prototype.submit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    UserLoginComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._data$ = this.store.pipe(select(isAuthenticated));
        // this.store.dispatch(new MailSignUp());
    };
    UserLoginComponent.decorators = [
        { type: Component, args: [{
                    selector: 'area-user-login',
                    template: "<mat-tab-group class=\"tab-login\" animationDuration=\"200ms\" mat-stretch-tabs>\n\t<!---->\n\t<mat-tab label=\"Crear cuenta\">\n\t\t<ng-template matTabContent>\n\t\t\t<area-user-form (submit)=\"submit()\"></area-user-form>\n\t\t</ng-template>\n\t</mat-tab>\n\t<!---->\n\t<mat-tab label=\"Iniciar sesi\u00F3n\">\n\t\t<ng-template matTabContent>\n\t\t\t<area-user-login-form (submit)=\"submit()\"></area-user-login-form>\n\t\t</ng-template>\n\t</mat-tab>\n\t<!--  -->\n</mat-tab-group>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    UserLoginComponent.ctorParameters = function () { return [
        { type: Store },
        { type: XAuthService }
    ]; };
    return UserLoginComponent;
}());
if (false) {
    /** @type {?} */
    UserLoginComponent.prototype.spinner;
    /** @type {?} */
    UserLoginComponent.prototype._data$;
    /**
     * @type {?}
     * @private
     */
    UserLoginComponent.prototype.store;
    /**
     * @type {?}
     * @private
     */
    UserLoginComponent.prototype.service;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/services/xuser.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var XuserService = /** @class */ (function () {
    function XuserService(store, xauthService) {
        this.store = store;
        this.xauthService = xauthService;
        this.authenticated = this.store.pipe(select(isAuthenticated));
        this.user = this.store.pipe(select(SelectPublic));
        /**
         * 	Estado de autenticacion
         */
        this.xauth = this.store.pipe(select(isAuthenticated));
        /**
         * 	Estado de autenticacion
         */
        this.isnew = this.store.pipe(select(isNew));
        /**
         * Estado del usuario actual
         */
        this.xuser = this.user;
        /**
             * Buscar un usuario
             */
        /**
         * ipUser
         */
        this.ipUser = this.xauthService.getIpUser();
    }
    /**
     * @param {?} id
     * @return {?}
     */
    XuserService.prototype.GetUserServer = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.xauthService.GetUserFires(id);
    };
    /**
     * Crear un usuario
     */
    /**
     * Crear un usuario
     * @param {?} user
     * @return {?}
     */
    XuserService.prototype.CreateUserServer = /**
     * Crear un usuario
     * @param {?} user
     * @return {?}
     */
    function (user) {
        return this.xauthService.createUserFirestore(user);
    };
    /**
     * Actualizar un usuario in firebase
     */
    /**
     * Actualizar un usuario in firebase
     * @param {?} uid
     * @param {?} user
     * @return {?}
     */
    XuserService.prototype.UpdateUserServer = /**
     * Actualizar un usuario in firebase
     * @param {?} uid
     * @param {?} user
     * @return {?}
     */
    function (uid, user) {
        return this.xauthService.UpdateUserFire(uid, user);
    };
    /**
     * Actualizar un usuario in Store
     */
    /**
     * Actualizar un usuario in Store
     * @param {?} uid
     * @param {?} user
     * @return {?}
     */
    XuserService.prototype.UpdateUserLocal = /**
     * Actualizar un usuario in Store
     * @param {?} uid
     * @param {?} user
     * @return {?}
     */
    function (uid, user) {
        this.store.dispatch(new UpdatePublic(uid, user));
    };
    /**
     * @return {?}
     */
    XuserService.prototype.SingOut = /**
     * @return {?}
     */
    function () {
        this.store.dispatch(new Logout());
    };
    /**
     * initUser
     */
    /**
     * initUser
     * @return {?}
     */
    XuserService.prototype.InitUserLoad = /**
     * initUser
     * @return {?}
     */
    function () {
        this.store.dispatch(new xGetUser());
    };
    /**
     * signInGoogle
     */
    /**
     * signInGoogle
     * @param {?} proveedor
     * @return {?}
     */
    XuserService.prototype.SignInSocial = /**
     * signInGoogle
     * @param {?} proveedor
     * @return {?}
     */
    function (proveedor) {
        this.store.dispatch(new SignInSocial(proveedor));
    };
    /**
     * resetPassword
     */
    /**
     * resetPassword
     * @param {?} email
     * @return {?}
     */
    XuserService.prototype.resetPassword = /**
     * resetPassword
     * @param {?} email
     * @return {?}
     */
    function (email) {
        return this.xauthService.resetPassword(email);
    };
    XuserService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    XuserService.ctorParameters = function () { return [
        { type: Store },
        { type: XAuthService }
    ]; };
    /** @nocollapse */ XuserService.ngInjectableDef = ɵɵdefineInjectable({ factory: function XuserService_Factory() { return new XuserService(ɵɵinject(Store), ɵɵinject(XAuthService)); }, token: XuserService, providedIn: "root" });
    return XuserService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    XuserService.prototype.authenticated;
    /**
     * @type {?}
     * @private
     */
    XuserService.prototype.user;
    /**
     * 	Estado de autenticacion
     * @type {?}
     */
    XuserService.prototype.xauth;
    /**
     * 	Estado de autenticacion
     * @type {?}
     */
    XuserService.prototype.isnew;
    /**
     * Estado del usuario actual
     * @type {?}
     */
    XuserService.prototype.xuser;
    /**
     * ipUser
     * @type {?}
     */
    XuserService.prototype.ipUser;
    /**
     * @type {?}
     * @private
     */
    XuserService.prototype.store;
    /**
     * @type {?}
     * @private
     */
    XuserService.prototype.xauthService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/user-login-form/user-login-form.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// import { MailSignUp } from '../core/actions/xuser.actions';
var UserLoginFormComponent = /** @class */ (function () {
    function UserLoginFormComponent(fb, router, xuser, XAuthService) {
        this.fb = fb;
        this.router = router;
        this.xuser = xuser;
        this.XAuthService = XAuthService;
        this.submit = new EventEmitter();
        this.errorMatcher = new MoocErrorMatcher();
        // modal aviso legal
        //   ModalAvisoLegal: MatDialogRef<ModalLegalComponent>;
        this.unsubscribe$ = new Subject();
        this.resetPass$ = new BehaviorSubject(false);
        this.loader$ = new BehaviorSubject({ state: false, error: false });
        this.hide = true;
        this.hideConfirm = true;
        this.hideLogin = true;
        this.newUser = true; // to toggle login or signup form
    }
    /**
     * @return {?}
     */
    UserLoginFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.buildForm();
    };
    /**
     * @return {?}
     */
    UserLoginFormComponent.prototype.resetValuePass = /**
     * @return {?}
     */
    function () {
        this.userForm.setValue({
            email: this.userForm.value['email'],
            password: '',
        });
    };
    /**
     * @return {?}
     */
    UserLoginFormComponent.prototype.copyEmail = /**
     * @return {?}
     */
    function () {
        this.userFormReset.setValue({
            email: this.userForm.value['email']
        });
    };
    /**
     * @return {?}
     */
    UserLoginFormComponent.prototype.toggleForm = /**
     * @return {?}
     */
    function () {
        this.newUser = !this.newUser;
    };
    /**
     * @return {?}
     */
    UserLoginFormComponent.prototype.loginSubmit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.XAuthService.signInWithEmailAndPassword("" + this.userForm.value['email'], "" + this.userForm.value['password'])
            .pipe(takeUntil(this.unsubscribe$), catchError((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            throw new Error(error);
        })))
            .subscribe((/**
         * @param {?} _result
         * @return {?}
         */
        function (_result) {
            // Si el ingreso fue exitoso:
            if (_result.user)
                _this.changeStateLoader(true, false), _this.router.navigate(["/escritorio"]);
            // Solo si existe error
            else if (_result.code)
                _this.changeStateLoader(true, true),
                    // SI existe error desactivar despues del tiempo dispuesto
                    setTimeout((/**
                     * @return {?}
                     */
                    function () {
                        _this.changeStateLoader(false, false);
                    }), 2000);
        }));
        this.submit.emit();
    };
    /**
     * @return {?}
     */
    UserLoginFormComponent.prototype.resetPassword = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.userFormReset.value['email'] != '') {
            this.xuser.resetPassword(this.userFormReset.value['email'])
                .pipe(takeUntil(this.unsubscribe$), catchError((/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                // Retornar error si falla en el servidor
                throw new Error(error);
            })))
                .subscribe((/**
             * @param {?} _result
             * @return {?}
             */
            function (_result) {
                // Por defecto firestore retorna undefined si el correo fue enviado,
                // por lo que se entiende que cuando finaliza la transaccion retornara undefined, de lo contrario sera error
                if (_result === undefined)
                    setTimeout((/**
                     * @return {?}
                     */
                    function () {
                        _this.changeStateLoader(false, false),
                            // /////////////////
                            // ERROR NO DESTRUYE EL FORM Y DEJA LA CONTRAEÑA EN EL CAMPO DE PASS
                            _this.resetValuePass(),
                            // /////////////////
                            _this.resetPass$.next(false);
                    }), 4000);
                // Solo si existe error
                else if (_result.code)
                    _this.changeStateLoader(true, true),
                        // SI existe error desactivar despues del tiempo dispuesto
                        setTimeout((/**
                         * @return {?}
                         */
                        function () {
                            _this.changeStateLoader(false, false);
                        }), 2000);
            }));
        }
    };
    /**
     * @return {?}
     */
    UserLoginFormComponent.prototype.buildForm = /**
     * @return {?}
     */
    function () {
        this.userForm = this.fb.group({
            'email': ['', [
                    Validators.required,
                    Validators.email,
                ]],
            'password': ['', [
                    Validators.required,
                    Validators.minLength(6),
                    Validators.maxLength(20)
                ]],
        });
        this.userFormReset = this.fb.group({
            'email': ['', [
                    Validators.required,
                    Validators.email,
                ]],
        });
    };
    // equalto(field_name): ValidatorFn {
    // 	return (control: AbstractControl): { [key: string]: any } => {
    // 		let input = control.value;
    // 		let isValid = control.root.value[field_name] == input
    // 		if (!isValid)
    // 			return { 'equalTo': { isValid } }
    // 		else
    // 			return null;
    // 	};
    // }
    // equalto(field_name): ValidatorFn {
    // 	return (control: AbstractControl): { [key: string]: any } => {
    // 		let input = control.value;
    // 		let isValid = control.root.value[field_name] == input
    // 		if (!isValid)
    // 			return { 'equalTo': { isValid } }
    // 		else
    // 			return null;
    // 	};
    // }
    /**
     * @param {?=} state
     * @param {?=} error
     * @return {?}
     */
    UserLoginFormComponent.prototype.changeStateLoader = 
    // equalto(field_name): ValidatorFn {
    // 	return (control: AbstractControl): { [key: string]: any } => {
    // 		let input = control.value;
    // 		let isValid = control.root.value[field_name] == input
    // 		if (!isValid)
    // 			return { 'equalTo': { isValid } }
    // 		else
    // 			return null;
    // 	};
    // }
    /**
     * @param {?=} state
     * @param {?=} error
     * @return {?}
     */
    function (state, error) {
        // const current = this.loader$.getValue()
        this.loader$.next({
            state: state,
            error: error
        });
    };
    /**
     * @return {?}
     */
    UserLoginFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    UserLoginFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'area-user-login-form',
                    template: "<div *ngIf=\"!(resetPass$ | async); then iniciar else reset\"></div>\n<ng-container *ngIf=\"loader$ | async as loader\">\n\t<area-loader *ngIf=\"loader.state\" [type]=\"'spinner'\" [isError]=\"loader.error\">\n\t\t<!-- <mat-icon *ngIf=\"loader.error\">error_outline</mat-icon> -->\n\t\t<div *ngIf=\"!loader.error && (resetPass$ | async)\">\n\t\t\t<p>Hemos enviado un correo para restablecer la contrase\u00F1a</p>\n\t\t\t<h4>Revisa la bandeja de entrada</h4>\n\t\t</div>\n\t</area-loader>\n</ng-container>\n<ng-template #iniciar>\n\t<div class=\"form-container\">\n\t\t<form [formGroup]=\"userForm\" (ngSubmit)=\"loginSubmit()\" autocomplete=\"off\">\n\t\t\t<!-- Correo -->\n\t\t\t<mat-form-field class=\"example-full-width\">\n\t\t\t\t<input [errorStateMatcher]=\"errorMatcher\" matInput placeholder=\"Correo electr\u00F3nico\" type=\"email\"\n\t\t\t\t\tformControlName=\"email\" required onCopy=\"return false\" onDrag=\"return false\" onDrop=\"return false\"\n\t\t\t\t\tonPaste=\"return false\">\n\t\t\t\t<mat-error *ngIf=\"userForm.controls.email.hasError('required')\">El correo electr\u00F3nico es requerido.\n\t\t\t\t</mat-error>\n\t\t\t</mat-form-field>\n\t\t\t<!-- contrase\u00F1a -->\n\t\t\t<mat-form-field>\n\t\t\t\t<input matInput [errorStateMatcher]=\"errorMatcher\" placeholder=\"Ingresa una contrase\u00F1a\"\n\t\t\t\t\t[type]=\"hide ? 'password' : 'text'\" formControlName=\"password\" required onCopy=\"return false\"\n\t\t\t\t\tonDrag=\"return false\" onDrop=\"return false\" onPaste=\"return false\">\n\t\t\t\t<mat-icon matSuffix class=\"cursor-pointer\" (click)=\"hide = !hide\">\n\t\t\t\t\t{{hide ? 'visibility' : 'visibility_off'}}\n\t\t\t\t</mat-icon>\n\t\t\t\t<mat-error *ngIf=\"userForm.controls.password.hasError('required')\">La contrase\u00F1a es requerida.</mat-error>\n\t\t\t\t<mat-error *ngIf=\"userForm.controls.password.hasError('minlength')\">La contrase\u00F1a es requerida.</mat-error>\n\t\t\t</mat-form-field>\n\t\t\t<button type=\"submit\" class=\"btn-form\" mat-flat-button color=\"primary\" [disabled]=\"!userForm.valid\"\n\t\t\t\t(click)=\"changeStateLoader(true, false)\">INGRESAR</button>\n\t\t\t<button mat-button color=\"primary\" class=\"btn-pass\" (click)=\"copyEmail(); resetPass$.next(true)\">He olvidado\n\t\t\t\tmi contrase\u00F1a</button>\n\t\t</form>\n\t</div>\n</ng-template>\n<ng-template #reset>\n\t<!-- <ng-container *ngIf=\"loader$ | async as loader\">\n\t\t\t\t<area-loader *ngIf=\"loader.state\" [type]=\"'spinner'\" [isError]=\"loader.error\"></area-loader>\n\t\t</ng-container> -->\n\t<div class=\"form-container\">\n\t\t<form *ngIf=\"resetPass$ | async\" [formGroup]=\"userFormReset\" (ngSubmit)=\"resetPassword()\" autocomplete=\"off\">\n\t\t\t<br>\n\t\t\t<!-- Correo -->\n\t\t\t<mat-form-field class=\"example-full-width\">\n\t\t\t\t<input [errorStateMatcher]=\"errorMatcher\" matInput placeholder=\"Correo electr\u00F3nico\" type=\"email\"\n\t\t\t\t\tformControlName=\"email\" required onCopy=\"return false\" onDrag=\"return false\" onDrop=\"return false\"\n\t\t\t\t\tonPaste=\"return false\">\n\t\t\t\t<mat-error *ngIf=\"userFormReset.controls.email.hasError('required')\">El correo electr\u00F3nico es requerido.</mat-error>\n\t\t\t</mat-form-field>\n\t\t\t<button type=\"submit\" mat-flat-button class=\"btn-form\" color=\"primary\" [disabled]=\"!userFormReset.valid\"\n\t\t\t\t(click)=\"changeStateLoader(true, false)\">Restablecer\n\t\t\t\tcontrase\u00F1a</button>\n\t\t\t\t<button mat-button color=\"primary\" class=\"btn-pass\" (click)=\"resetPass$.next(false)\">Iniciar sesi\u00F3n</button>\n\t\t</form>\n\t</div>\n</ng-template>",
                    styles: [":host form{padding:20px}:host .mat-form-field{width:100%;margin-bottom:15px}:host .btn-form{padding:5px 20px;border-radius:30px;margin:0 auto;display:block;transition:.7s;font-weight:700}:host .form-container{min-height:350px}:host .btn-pass{margin:40px auto 0;display:block}"]
                }] }
    ];
    /** @nocollapse */
    UserLoginFormComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: Router },
        { type: XuserService },
        { type: XAuthService }
    ]; };
    UserLoginFormComponent.propDecorators = {
        submit: [{ type: Output }]
    };
    return UserLoginFormComponent;
}());
if (false) {
    /** @type {?} */
    UserLoginFormComponent.prototype.submit;
    /** @type {?} */
    UserLoginFormComponent.prototype.errorMatcher;
    /**
     * @type {?}
     * @private
     */
    UserLoginFormComponent.prototype.unsubscribe$;
    /** @type {?} */
    UserLoginFormComponent.prototype.resetPass$;
    /** @type {?} */
    UserLoginFormComponent.prototype.loader$;
    /** @type {?} */
    UserLoginFormComponent.prototype.hide;
    /** @type {?} */
    UserLoginFormComponent.prototype.hideConfirm;
    /** @type {?} */
    UserLoginFormComponent.prototype.hideLogin;
    /** @type {?} */
    UserLoginFormComponent.prototype.userForm;
    /** @type {?} */
    UserLoginFormComponent.prototype.userFormReset;
    /** @type {?} */
    UserLoginFormComponent.prototype.newUser;
    /**
     * @type {?}
     * @private
     */
    UserLoginFormComponent.prototype.fb;
    /**
     * @type {?}
     * @private
     */
    UserLoginFormComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    UserLoginFormComponent.prototype.xuser;
    /**
     * @type {?}
     * @private
     */
    UserLoginFormComponent.prototype.XAuthService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/number-tracker/number-tracker.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IInterval() { }
if (false) {
    /** @type {?} */
    IInterval.prototype.days;
    /** @type {?} */
    IInterval.prototype.hours;
    /** @type {?} */
    IInterval.prototype.minutes;
    /** @type {?} */
    IInterval.prototype.seconds;
}
var NumberTrackerComponent = /** @class */ (function () {
    function NumberTrackerComponent() {
        this.countInterval = 1000;
        this._onDestroy$ = new Subject();
    }
    /**
     * @return {?}
     */
    NumberTrackerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.endRange = Date.now() + this.end;
        this._counterSub$ = timer(0, this.countInterval).pipe(takeWhile((/**
         * @param {?} x
         * @return {?}
         */
        function (x) { return _this.validIntervalCountdown(_this.endRange); })), map((/**
         * @param {?} interval
         * @return {?}
         */
        function (interval) { return _this.getIntervalTime(_this.endRange, Date.now()); })), map((/**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            /** @type {?} */
            var seconds = val.seconds < 10 ? '0' + ("" + val.seconds) : val.seconds;
            /** @type {?} */
            var minutes = val.minutes < 10 ? '0' + ("" + val.minutes) : val.minutes;
            return "" + minutes + ":" + ("" + seconds);
        })), takeUntil(this._onDestroy$));
    };
    /**
     * @private
     * @param {?} timeToGo
     * @return {?}
     */
    NumberTrackerComponent.prototype.validIntervalCountdown = /**
     * @private
     * @param {?} timeToGo
     * @return {?}
     */
    function (timeToGo) {
        return (timeToGo - Date.now()) >= 0 ? true : false;
    };
    /**
     * @private
     * @param {?} dateA
     * @param {?} dateB
     * @return {?}
     */
    NumberTrackerComponent.prototype.getIntervalTime = /**
     * @private
     * @param {?} dateA
     * @param {?} dateB
     * @return {?}
     */
    function (dateA, dateB) {
        /** @type {?} */
        var intervalTime = Math.floor((dateA - dateB) / 1000);
        return this.getTime(intervalTime);
    };
    /**
     * @private
     * @param {?} time
     * @return {?}
     */
    NumberTrackerComponent.prototype.getTime = /**
     * @private
     * @param {?} time
     * @return {?}
     */
    function (time) {
        /** @type {?} */
        var interval = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        interval.days = Math.floor(time / 86400);
        time -= interval.days * 86400;
        interval.hours = Math.floor(time / 3600) % 24;
        time -= interval.hours * 3600;
        interval.minutes = Math.floor(time / 60) % 60;
        time -= interval.minutes * 60;
        interval.seconds = time % 60;
        return interval;
    };
    /**
     * @return {?}
     */
    NumberTrackerComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._onDestroy$.next();
        this._onDestroy$.complete();
    };
    NumberTrackerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'area-number-tracker',
                    template: "<span *ngIf=\"_counterSub$ | async as crr\">{{ crr }}</span>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    NumberTrackerComponent.ctorParameters = function () { return []; };
    NumberTrackerComponent.propDecorators = {
        countInterval: [{ type: Input }],
        end: [{ type: Input }]
    };
    return NumberTrackerComponent;
}());
if (false) {
    /** @type {?} */
    NumberTrackerComponent.prototype.endRange;
    /** @type {?} */
    NumberTrackerComponent.prototype.countInterval;
    /** @type {?} */
    NumberTrackerComponent.prototype.end;
    /** @type {?} */
    NumberTrackerComponent.prototype.currentNumber;
    /** @type {?} */
    NumberTrackerComponent.prototype._counterSub$;
    /**
     * @type {?}
     * @private
     */
    NumberTrackerComponent.prototype._onDestroy$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/x-btn-google/x-btn-google.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var XBtnGoogleComponent = /** @class */ (function () {
    function XBtnGoogleComponent(xservice) {
        this.xservice = xservice;
    }
    /**
     * @return {?}
     */
    XBtnGoogleComponent.prototype.signInWithGoogle = /**
     * @return {?}
     */
    function () {
        this.xservice.SignInSocial('google');
    };
    /**
     * @return {?}
     */
    XBtnGoogleComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    XBtnGoogleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'area-x-btn-google',
                    template: "<button mat-button (click)=\"signInWithGoogle()\" class=\"btn-google\">\n  <svg viewBox=\"0 0 307 307\" class=\"icon-g\">\n    <path\n      d=\"M163.72,175.26h51.52A65.5,65.5,0,1,1,197.46,105a7.09,7.09,0,0,0,9.65,0L226,87.19a7.08,7.08,0,0,0,0-10.29A105.1,105.1,0,0,0,155.62,48C97.45,46.88,48.43,94.57,48,152.75a105.49,105.49,0,0,0,210.82,6.68c.09-.69.14-24.21.14-24.21H163.72a7.06,7.06,0,0,0-7.07,7.07V168.2A7.06,7.06,0,0,0,163.72,175.26Z\" />\n  </svg>\n  <span>Ingresar con Google</span>\n</button>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".btn-google{height:50px;width:100%;background:#e8372d}.btn-google span{color:#fff}.icon-g{padding:5px;width:55px;height:38px;fill:#fff;position:absolute;left:0;border-right:1px solid rgba(224,224,224,.5)}"]
                }] }
    ];
    /** @nocollapse */
    XBtnGoogleComponent.ctorParameters = function () { return [
        { type: XuserService }
    ]; };
    return XBtnGoogleComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    XBtnGoogleComponent.prototype.xservice;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/x-btn-facebook/x-btn-facebook.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var XBtnFacebookComponent = /** @class */ (function () {
    function XBtnFacebookComponent(xservice) {
        this.xservice = xservice;
    }
    /**
     * @return {?}
     */
    XBtnFacebookComponent.prototype.signInWithFacebook = /**
     * @return {?}
     */
    function () {
        this.xservice.SignInSocial('facebook');
    };
    /**
     * @return {?}
     */
    XBtnFacebookComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    XBtnFacebookComponent.decorators = [
        { type: Component, args: [{
                    selector: 'area-x-btn-facebook',
                    template: "<div matTooltip=\"Pronto podras ingresar con Facebook\">\n  <button disabled mat-button (click)=\"signInWithFacebook()\" class=\"btn-face\">\n    <svg viewBox=\"0 0 307 307\" class=\"icon-f\">\n      <path\n        d=\"M208.24,44.05l-28.4,0c-31.9,0-52.52,21.15-52.52,53.9v24.85H98.76a4.46,4.46,0,0,0-4.46,4.46v36a4.46,4.46,0,0,0,4.46,4.46h28.56v90.85a4.47,4.47,0,0,0,4.46,4.47H169a4.46,4.46,0,0,0,4.46-4.47V167.68h33.39a4.46,4.46,0,0,0,4.47-4.46v-36a4.47,4.47,0,0,0-4.47-4.46H173.5V101.68c0-10.12,2.42-15.26,15.61-15.26h19.13a4.47,4.47,0,0,0,4.46-4.47V48.51A4.46,4.46,0,0,0,208.24,44.05Z\" />\n    </svg>\n    <span>Ingresar con Facebook</span>\n  </button>\n</div>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".btn-face{height:50px;width:100%;background:#39579a;margin-top:20px;opacity:.4}.btn-face span{color:#fff}.icon-f{padding:5px;width:55px;height:38px;fill:#fff;position:absolute;left:0;border-right:1px solid rgba(224,224,224,.5)}"]
                }] }
    ];
    /** @nocollapse */
    XBtnFacebookComponent.ctorParameters = function () { return [
        { type: XuserService }
    ]; };
    return XBtnFacebookComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    XBtnFacebookComponent.prototype.xservice;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/loader/loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoaderComponent = /** @class */ (function () {
    function LoaderComponent() {
        this.type = 'bar';
    }
    /**
     * @return {?}
     */
    LoaderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    LoaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'area-loader',
                    template: "<mat-card class=\"container\">\n\t<ng-content></ng-content>\n\t<div>\n\t\t<!-- <mat-progress-bar *ngIf=\"type === 'bar'\" [color]=\"(isError ? 'warn' : 'accent')\" class=\"bar\" mode=\"indeterminate\"></mat-progress-bar> -->\n\t\t<mat-spinner class=\"spinner\" [color]=\"(isError ? 'warn' : 'accent')\" diameter=\"40\" *ngIf=\"type === 'spinner'\">\n\t\t</mat-spinner>\n\t\t<h3 *ngIf=\"isError\">Error</h3>\n\t</div>\n</mat-card>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".container{width:100%;height:100%;position:absolute;top:0;bottom:0;right:0;left:0;z-index:999;padding:0;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center}.container .bar{position:absolute;bottom:0}.container .spinner{-ms-grid-column-align:center;justify-self:center;-ms-grid-row-align:center;align-self:center;margin:0 auto}.container h3{color:#f44336;margin-top:10px}"]
                }] }
    ];
    /** @nocollapse */
    LoaderComponent.ctorParameters = function () { return []; };
    LoaderComponent.propDecorators = {
        isError: [{ type: Input }],
        type: [{ type: Input }]
    };
    return LoaderComponent;
}());
if (false) {
    /** @type {?} */
    LoaderComponent.prototype.isError;
    /** @type {?} */
    LoaderComponent.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/area-user.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AreaUserModule = /** @class */ (function () {
    function AreaUserModule() {
    }
    AreaUserModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [UserFormComponent, UserLoginComponent, UserLoginFormComponent, VerifiedComponent, NumberTrackerComponent, XBtnGoogleComponent, XBtnFacebookComponent, LoaderComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatInputModule,
                        MatCardModule,
                        MatTabsModule,
                        MatButtonModule,
                        MatIconModule,
                        MatDialogModule,
                        MatProgressBarModule,
                        MatProgressSpinnerModule,
                        EffectsModule.forFeature([XUserEffects]),
                        StoreModule.forFeature('xpublic', ActionsXPublicReducer),
                        MatTooltipModule
                    ],
                    exports: [UserLoginComponent, VerifiedComponent, XBtnGoogleComponent, XBtnFacebookComponent],
                    entryComponents: [
                        VerifiedComponent
                    ],
                    providers: [
                        XuserService
                    ]
                },] }
    ];
    return AreaUserModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/core/services/xguard.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var XguardService = /** @class */ (function () {
    function XguardService(router, afAuth, _snackBar) {
        this.router = router;
        this.afAuth = afAuth;
        this._snackBar = _snackBar;
    }
    /**
     * @param {?} next
     * @param {?} state
     * @return {?}
     */
    XguardService.prototype.canActivate = /**
     * @param {?} next
     * @param {?} state
     * @return {?}
     */
    function (next, state) {
        var _this = this;
        return this.afAuth.authState.pipe(take(1), map((/**
         * @param {?} user
         * @return {?}
         */
        function (user) { return !!user; })), tap((/**
         * @param {?} loggedIn
         * @return {?}
         */
        function (loggedIn) {
            _this.guard = loggedIn;
            if (!loggedIn) {
                _this._snackBar.open('Debes iniciar sesión antes de continuar', 'Entendido', {
                    duration: 3000,
                    horizontalPosition: 'right',
                });
                setTimeout((/**
                 * @return {?}
                 */
                function () { _this.router.navigate(['/login']); }), 1700);
            }
        })));
    };
    XguardService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    XguardService.ctorParameters = function () { return [
        { type: Router },
        { type: AngularFireAuth },
        { type: MatSnackBar$1 }
    ]; };
    /** @nocollapse */ XguardService.ngInjectableDef = ɵɵdefineInjectable({ factory: function XguardService_Factory() { return new XguardService(ɵɵinject(Router), ɵɵinject(AngularFireAuth), ɵɵinject(MatSnackBar$1)); }, token: XguardService, providedIn: "root" });
    return XguardService;
}());
if (false) {
    /** @type {?} */
    XguardService.prototype.guard;
    /**
     * @type {?}
     * @private
     */
    XguardService.prototype.router;
    /**
     * @type {?}
     * @private
     */
    XguardService.prototype.afAuth;
    /**
     * @type {?}
     * @private
     */
    XguardService.prototype._snackBar;
}
var XloginGuard = /** @class */ (function () {
    function XloginGuard(router, afAuth, _snackBar) {
        this.router = router;
        this.afAuth = afAuth;
        this._snackBar = _snackBar;
    }
    /**
     * @param {?} next
     * @param {?} state
     * @return {?}
     */
    XloginGuard.prototype.canActivate = /**
     * @param {?} next
     * @param {?} state
     * @return {?}
     */
    function (next, state) {
        var _this = this;
        return this.afAuth.authState.pipe(take(1), map((/**
         * @param {?} user
         * @return {?}
         */
        function (user) { return !user; })), tap((/**
         * @param {?} loggedIn
         * @return {?}
         */
        function (loggedIn) {
            if (!loggedIn)
                _this.router.navigate(['/cursos/escritorio']);
        })));
    };
    XloginGuard.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    XloginGuard.ctorParameters = function () { return [
        { type: Router },
        { type: AngularFireAuth },
        { type: MatSnackBar$1 }
    ]; };
    /** @nocollapse */ XloginGuard.ngInjectableDef = ɵɵdefineInjectable({ factory: function XloginGuard_Factory() { return new XloginGuard(ɵɵinject(Router), ɵɵinject(AngularFireAuth), ɵɵinject(MatSnackBar$1)); }, token: XloginGuard, providedIn: "root" });
    return XloginGuard;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    XloginGuard.prototype.router;
    /**
     * @type {?}
     * @private
     */
    XloginGuard.prototype.afAuth;
    /**
     * @type {?}
     * @private
     */
    XloginGuard.prototype._snackBar;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: area-user.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AreaUserModule, ErrorSelector, SelectAllUser, SelectPublic, SelectmailVerifyIsWait, UserLoginComponent, UserSelector, VerifiedComponent, XBtnFacebookComponent, XBtnGoogleComponent, XguardService, XloginGuard, XuserService, isAuthenticated, isNew, selectPublicState, UserFormComponent as ɵa, ActionsXPublicReducer as ɵc, selectAll as ɵd, XAuthService as ɵe, UserLoginFormComponent as ɵf, ActionsService as ɵg, HelpersService as ɵh, NumberTrackerComponent as ɵi, LoaderComponent as ɵj, XUserEffects as ɵk, XmodalService as ɵl };
//# sourceMappingURL=area-user.js.map
